import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FillDgf.css";
import axios from "axios";
import { hasAnyPermission } from "../../permissions";

// Use same-origin /api in production (VPS), localhost:5000 in dev.
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

const steps = [
  "Guidelines",
  "Property Details",
  "Contact Details",
  "Documents",
  "Seasonal Trends",
  "Facilities",
  "Room Type",
  "Rate Plan with Rates",
  "Policy Details",
  "Payment Methods",
  "OTA Information",
  "Credentials",
  "Extra Charges",
  "FAQ",
  "Overview",
];

const FAQ_STEP = 13;       // replace with your real FAQ index in `steps`
const OVERVIEW_STEP = 14;  // "Overview" is steps[14] — FIXED: this was
// previously 15, one past where "Overview" actually sits in the `steps`
// array (steps.length is 15, so valid indices are 0-14). The Overview
// page's content still rendered despite this — renderStepContent's final
// `else` branch is a catch-all for "anything not matched above," so both
// 14 and 15 fell through to it — but the sidebar never gets a chance to
// mark "Overview" as the active step, since none of its circles (indices
// 0-14) ever equal 15. handleSubmit's setCurrentStep call below is fixed
// to match.

function MultiStepForm() {
  const navigate = useNavigate();

  // TEMPORARY: permission check disabled so everyone can submit for now,
  // per request. Original check (re-enable by uncommenting the line below
  // and removing the "true" line) required the "read_write_fill_dgf"
  // permission to be explicitly granted to a user in Settings before they
  // could submit:
  //   const canSubmitFillDgf = hasAnyPermission(["read_write_fill_dgf"]);
  const canSubmitFillDgf = true;

  const handleBackToHome = () => {
    navigate("/HomePage");
  };
  // start
  const [submittedData, setSubmittedData] = useState(null);
 const [formData, setFormData] = useState({ guidelinesComment:"",
  // PROPERTY DETAILS
  propertyName:"", propertyType:"", PropertyAddress:"", country:"", state:"", city:"", pinCode:"", bill:"", gst:"", receptionNumber:"", marketingNumber:"", propertyEmail:"",
  propertyWebsite:"", invoiceNumber:"", ratesAre:"", starCategory:"", importFuture:"", checkIn:"", checkOut:"", buildingFloors:"", buildingRooms:"", propertyComments:"",
  // CONTACT DETAILS
  ownerContactName:"", ownerDesignation:"", ownerDOB:"", ownerStateCity:"", ownerEmail:"", ownerMobileNumber:"",
  managerContactName:"", managerDesignation:"", managerEmail:"", managerMobileNumber:"",
  billingContactName:"", billingDesignation:"", billingEmail:"", billingMobileNumber:"",
  // DOCUMENTS
  gstCertificate:"",hasLeaseAgreement: false,
 leaseAgreement:"", msmeDocument:"", utilityBill:"", aadhaarCard:"", panCard:"", otherDocument:"", letterHead:"", documentComments:"",
  // SEASONAL TREANDS
  peakSeasons:"", midSeasons:"", lowSeasons:"", seasonalTrendsComments:"",
 // FACILITIES SECTION
Restaurant: false,
Terrace: false,
Lift: false,
WiFi: false,
TwentyFourService: false,
AirConditioner: false,
Garden: false,
RoomService: false,
Bar: false,

Sauna: false,
SaunaCharges: "",
AirportShuttle: false,
AirportShuttleCharges: "",
Jacuzzi: false,
JacuzziCharges: "",
WaterPark: false,
WaterParkCharges: "",
Spa: false,
SpaCharges: "",
Parking: false,
ParkingCharges: "",
FacilityforDisabled: false,
FacilityforDisabledCharges: "",
GameRoom: false,
GameRoomCharges: "",
PrivateTaxi: false,
PrivateTaxiCharges: "",

// POOL AMENITIES
PoolCover: false,
PoolTowels: false,

PrivatePool: false,
PrivatePoolCharges: "",
HeatedPool: false,
HeatedPoolCharges: "",
InfinityPool: false,
InfinityPoolCharges: "",
PlungePool: false,
PlungePoolCharges: "",
PoolWithView: false,
PoolWithViewCharges: "",
RoofTopPool: false,
RoofTopPoolCharges: "",
SaltWaterPool: false,
SaltWaterPoolCharges: "",
KidsPool: false,
KidsPoolCharges: "",

OpenAllYear: false,
AllAgesWelcome: false,
IndoorPoolWithView: false,

// RECEPTION SERVICES
InvoiceProvided: false,
TourDesk: false,

Lockers: false,
LockersCharges: "",
LuggageStorage: false,
LuggageStorageCharges: "",

// OUTDOOR FEATURES
OutdoorFurniture: false,
SunTerrace: false,

// ACTIVITIES
BicycleRental: false,
BicycleRentalCharges: "",
WalkingTours: false,
WalkingToursCharges: "",
Darts: false,
DartsCharges: "",
IndoorPlayArea: false,
IndoorPlayAreaCharges: "",
BoardGamesPuzzles: false,
BoardGamesPuzzlesCharges: "",
EveningEntertainment: false,
EveningEntertainmentCharges: "",
LiveMusicPerformance: false,
LiveMusicPerformanceCharges: "",
TableTennis: false,
TableTennisCharges: "",
Billiards: false,
BilliardsCharges: "",
Bonfire: false,
BonfireCharges: "",

// FOOD & DRINKS
SnackBar: false,
SnackBarCharges: "",
Wine: false,
WineCharges: "",
Fruits: false,
FruitsCharges: "",
Snacks: false,
SnacksCharges: "",

// CLEANING SERVICES
DailyHousekeeping: false,
IroningServices: false,
IroningServicesCharges: "",
Laundry: false,
LaundryCharges: "",

// WELLNESS
YogaClasses: false,
YogaClassesCharges: "",
Fitness: false,
FitnessCharges: "",
SpaFacilities: false,
SpaFacilitiesCharges: "",

// BUSINESS FACILITIES
FaxPhotocopying: false,
FaxPhotocopyingCharges: "",
BusinessCenter: false,
BusinessCenterCharges: "",
MeetingBanquetRooms: false,
MeetingBanquetRoomsCharges: "",

// SAFETY & SECURITY
FireExtinguisher: false,
CctvOutsideProperty: false,
CctvinCommonAreas: false,
SmokeAlarm: false,
SecurityAlarm: false,
KeyCardAccess: false,
TwentyFourSecurity: false,
SafetyDepositBox: false,

// GENERAL
SharedLoungeTVArea: false,
DesignatedSmokingArea: false,
TileMarbleFloor: false,
Soundproofing: false,
Fan: false,
FamilyRooms: false,
SmokingAllowed: false,
SmokingNotAllowed: false,

// ACCESSIBILITY
WheelchairAccessible: false,
UpperFloorsAccessiblebyElevator: false,

// LANGUAGES
Hindi: false,
English: false,
LocalLanguage: false,
facilitiesComments: "",

  // ROOM TYPE
  roomTypeName:"", roomSize:"", roomNumbers:"", baseAdult:"", maxAdult:"", baseChild:"", maxChild:"", maxOccupancy:"", roomInventory:"",
  roomPhotographs:"", 
  // ROOM LEVEL FACILITIES
  // BASIC AMENITIES
  Ac:"",ceilingFan:"",wallFan:"",balcony:"", view:"",window:"",flatScreenTv:"", foldupBed:"",sofaBed:"", sofa:"",radio:"",videoGames:"",trashCans:"",
  landline:"",dressingRoomTable:"", washingMachine:"", seatingArea:"", iron:"",desk:"",socketNearBed:"",featherPillow:"", blankets:"",others:"",
  // BATHROOM AMENITIES
  freeToiletries:"",pvtBathroom:"",sharedBathroom:"",toilet:"",toiletPaper:"",bathTub:"",bathRobe:"",shower:"",towel:"",hairdryer:"",slippers:"",
  spaBath:"",clothRack:"",dryingRack:"",toothBrush:"",toothPaste:"",shampoo:"",conditioner:"",bodySoap:"",showerCap:"",
  // KITCHENETTE AMENITIES
  electricKettle:"",diningArea:"",diningTable:"",toaster:"",waterBottle:"",gasStove:"",dishWasher:"",outdoorDiningArea:"",kitchen:"",minibar:"",
  microwave:"",refrigerator:"",teaCoffeeMaker:"",
  // FOOD AND DRINK
  wineGlasses:"",chocolateCookies:"",kidMeals:"",wineChampagne:"",barbeque:"",buffet:"",
  // SERVICE AND EXTRA AMENITIES
  fireAlarm:"", fireExtinguisherInsideRoom:"",lockersInsideRooms:"",alarmClock:"",wakeUpService:"",executiveLoungeAccess:"",
  roomTypeComments:"",
  // RATE PLAN
  ratePlanName:"", baseRates:"", extraAdultRate:"", extraChildRate:"", ep:"", cpBreakfast:"", mapBreakfast:"", mapLunch:"", apBreakfast:"", apLunch:"", apDinner:"", ratePlanComments:"", 
  // POLICY DETAILS
  unmarriedCouples:"", guestBelow18:"", groupOnlyMale:"", privateParties:"", guestInvite:"",
  accessibleForWheelchair:"", petsAllowed:"", petsAllowedCharges:"", twentyfourCheckin:"", childAgePolicy:"", childAgePolicyYears:"", extraBedPolicy:"", 
  nonVegAllowed:"", outsideFoodDeliveryAllowed:"", alcoholAllowed:"", firstAidKitProvided:"",
  bookingCancellationBefore:"", policyComments:"",
  // PAYMENT METHODS
  paymentMethods:"", accountNumber:"", accountHolderName:"", ifsc:"", branchName:"", cancelledCheque:"", paymentQr:"", paymentMethodComments:"",
  // OTA INFORMATION
  otaName:"", propertyCode:"", otaUserName:"", otaPassword:"", otaInfoComments:"", 
  // CREDENTIALS
  instaExists:"", instaUsername:"", instaPassword:"",
  facebookExists:"", facebookUsername:"", facebookPassword:"",
  googleProfileExists:"", googleProfile:"", primaryID:"", mobileNumberPresent:"", mobileNumberForUpdation:"",
  listingExists:"", phoneNumberTripadvisor:"", websiteExists:"", websiteDomain:"", websiteLink:"", websiteID:"", websitePassword:"", webmailID:"", webmailPassword:"", hotelID:"", hotelIDPassword:"",
  credentialComments:"",

  // EXTRA CHARGES
  extraChargeName:"", extraChargePrice:"", extraPercentageCharged:"", extraChargesComments:"", 

  // FAQ
  howManyRoomCategories:"", totalRoomInventories:"", uniqueSellingPoint:"", nearbyPopularLocations:"", liveLocation:"", faqComments:"",
});
 
// Handles input changes (keep as is)
const handleChange = (e) => {
  const { name, value, type, checked, multiple, options, files } = e.target;

  // Handle multi-select inputs
  if (multiple && options) {
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => option.value);
    setFormData((prev) => ({ ...prev, [name]: selectedValues }));
  }
  // Handle checkboxes (boolean fields)
  else if (type === "checkbox") {
    setFormData((prev) => ({ ...prev, [name]: checked }));
  }
  // Handle file uploads (single or multiple)
  else if (type === "file") {
    if (multiple) {
      const fileURLs = Array.from(files).slice(0, 4).map((file) => URL.createObjectURL(file)); // limit 4
      setFormData((prev) => ({ ...prev, [name]: fileURLs }));
    } else {
      const file = files[0];
      if (file) {
        setFormData((prev) => ({ ...prev, [name]: URL.createObjectURL(file) }));
      }
    }
  }
  // Handle normal text/select/textarea inputs
  else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};
// Optionally drop entirely empty rows so you don't show blank cards
// helper can be reused for any repeating-section array

// ✅ sanitizers and helpers
const sanitizeRows = (rows) =>
  (rows || []).filter((r) =>
    Object.entries(r || {}).some(([k, v]) => {
      if (k === "id") return false;
      if (Array.isArray(v)) return v.length > 0;
      if (v && typeof v === "object") return Object.values(v).some(Boolean);
      if (typeof v === "boolean") return v;
      return String(v ?? "").trim() !== "";
    })
  );

const normalizeRoomTypesForSubmit = (rows) =>
  (rows || []).map((rt) => ({
    ...rt,
    roomPhotographs: Array.isArray(rt.roomPhotographs)
      ? rt.roomPhotographs.map((f) =>
          typeof f === "string" ? f : f?.name || "photo"
        )
      : [],
  }));

// ✅ main submit
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // clean dynamic arrays (same as before)
    const cleanedExtraCharges = sanitizeRows(extraCharges);
    const cleanedOtaInfo = sanitizeRows(otaInfo);
    const cleanedRatePlans = sanitizeRows(ratePlans);
    const sanitizedRoomTypes = sanitizeRows(roomTypes);

    // 🔹 prepare roomTypes JSON (names only) – same style as before
    const cleanedRoomTypes = normalizeRoomTypesForSubmit(sanitizedRoomTypes);

    // 🔹 collect room photo File objects separately (for FormData)
    const roomPhotoFiles = [];
    sanitizedRoomTypes.forEach((rt, roomIndex) => {
      (rt.roomPhotographs || []).forEach((photo) => {
        if (photo instanceof File) {
          roomPhotoFiles.push({ roomIndex, file: photo });
        }
      });
    });

    // build main JSON payload (NO File objects inside)
    const payload = {
  ...formData,
  extraCharges: cleanedExtraCharges,
  otaInfo: cleanedOtaInfo,
  ratePlans: cleanedRatePlans,
  roomTypes: cleanedRoomTypes,

  createdBy: localStorage.getItem("loggedInUser") || "Unknown",
  createdByRole: localStorage.getItem("loggedInRole") || "",
};

    // 🔹 All document fields we want to treat as files
    const fileFields = [
      "gstCertificate",
      "leaseAgreement",
      "msmeDocument",
      "letterHead",
      "utilityBill",
      "aadhaarCard",
      "panCard",
      "otherDocument",
      "cancelledCheque",
      "paymentQr",
    ];

    // For JSON payload: keep only the file names (for Overview / list)
    fileFields.forEach((field) => {
      if (payload[field] instanceof File) {
        const name = payload[field].name;
        payload[`${field}Name`] = name; // optional extra name field
        payload[field] = name;          // string used on overview + /api/properties
      }
    });

    // 🔹 Build multipart body
    const body = new FormData();
    body.append("json", JSON.stringify(payload)); // all normal data

    // Attach actual document/payment file binaries
    fileFields.forEach((field) => {
      if (formData[field] instanceof File) {
        body.append(field, formData[field]); // name must match <input name="">
      }
    });

    // 🔹 Attach room-type photo binaries (one field per room index)
    roomPhotoFiles.forEach(({ roomIndex, file }) => {
      body.append(`roomTypes[${roomIndex}].roomPhotographs`, file);
      // or: body.append(`roomTypes[${roomIndex}].roomPhotographs`, file, file.name);
    });


const response = await axios.post(
  `${API_BASE}/api/submit-form`,
  body,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);


    alert("✅ Data saved successfully!");
    console.log("Server response:", response.data);

    // submittedData uses payload (no File objects) -> Overview still works
    setSubmittedData(payload);
    setCurrentStep(14); // matches OVERVIEW_STEP / steps[14] — see fix above
  } catch (error) {
  console.error("❌ Error saving data:", error);

  const msg =
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.message ||
    "Something went wrong while saving data!";

  alert(msg);
}

};




  // end
  const [currentStep, setCurrentStep] = useState(0);
  const nextStep = () => {
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
  };
  const prevStep = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };
  // 🔵 Handle click on a sidebar step circle
  const goToStep = (index) => {
    setCurrentStep(index);
  };

// 🛏️ ROOM TYPES (flat, like otaInfo/extraCharges)
const [roomTypes, setRoomTypes] = useState([
  {
    id: Date.now(),
    name: "",
    bedType: "",
    roomSize: "",
    roomNumbers: "",
    bedsCountPerRoom: "",
    baseAdult: "",
    maxAdult: "",
    baseChild: "",
    maxChild: "",
    maxOccupancy: "",
    roomInventory: "",
    rateThresholdMin: "",
    rateThresholdMax: "",
    extraMattressCount: "",
    extraMattressPriceAdult: "",
    extraMattressPriceChild: "",
    viewFromRoom: "",
    windowOpenable: "",
    privateBalcony: "",
    numberOfWashrooms: "",
    breakfastType: "",
    acType: "",
    roomPhotographs: [],   // Files or strings
    amenities: {},         // { key: true/false }
    comments: "",          // per-room notes
  },
]);

const addRoomType = () => {
  setRoomTypes(prev => [
    ...prev,
    {
      id: Date.now(),
      name: "",
      bedType: "",
      roomSize: "",
      roomNumbers: "",
      bedsCountPerRoom: "",
      baseAdult: "",
      maxAdult: "",
      baseChild: "",
      maxChild: "",
      maxOccupancy: "",
      roomInventory: "",
      rateThresholdMin: "",
      rateThresholdMax: "",
      extraMattressCount: "",
      extraMattressPriceAdult: "",
      extraMattressPriceChild: "",
      viewFromRoom: "",
      windowOpenable: "",
      privateBalcony: "",
      numberOfWashrooms: "",
      breakfastType: "",
      acType: "",
      roomPhotographs: [],
      amenities: {},
      comments: "",
    },
  ]);
};

const removeRoomType = (id) => {
  setRoomTypes(prev => (prev.length > 1 ? prev.filter(r => r.id !== id) : prev));
};

const handleRoomTypeChange = (id, field, value) => {
  setRoomTypes(prev => prev.map(r => (r.id === id ? { ...r, [field]: value } : r)));
};

const handleAmenityToggle = (id, key, checked) => {
  setRoomTypes(prev =>
    prev.map(r =>
      r.id === id ? { ...r, amenities: { ...r.amenities, [key]: checked } } : r
    )
  );
};

const handlePhotosAdd = (id, fileList) => {
  const incoming = Array.from(fileList || []);
  setRoomTypes(prev =>
    prev.map(r => {
      if (r.id !== id) return r;
      const next = [...r.roomPhotographs, ...incoming];
      if (next.length > 4) {
        alert("❌ Max 4 photos per room type.");
        return { ...r, roomPhotographs: next.slice(0, 4) };
      }
      return { ...r, roomPhotographs: next };
    })
  );
};

const handlePhotoRemove = (id, index) => {
  setRoomTypes(prev =>
    prev.map(r =>
      r.id === id
        ? { ...r, roomPhotographs: r.roomPhotographs.filter((_, i) => i !== index) }
        : r
    )
  );
};

// 💰 RATE PLAN
const [ratePlans, setRatePlans] = useState([
  {
    id: 1,
    roomTypeName: "",     // moved into the card so each plan can differ
    ratePlanName: "",
    baseRates: "",
    extraAdultRate: "",
    extraChildRate: "",

    // Meal plan toggles (per card)
    ep: false,            // EP has no extra prices
    hasCP: false,
    cpBreakfast: "",

    hasMAP: false,
    mapBreakfast: "",
    mapLunch: "",

    hasAP: false,
    apBreakfast: "",
    apLunch: "",
    apDinner: "",
  },
]);

const addRatePlan = () => {
  setRatePlans((prev) => [
    ...prev,
    {
      id: Date.now(),
      roomTypeName: "",
      ratePlanName: "",
      baseRates: "",
      extraAdultRate: "",
      extraChildRate: "",
      ep: false,
      hasCP: false,
      cpBreakfast: "",
      hasMAP: false,
      mapBreakfast: "",
      mapLunch: "",
      hasAP: false,
      apBreakfast: "",
      apLunch: "",
      apDinner: "",
    },
  ]);
};

const removeRatePlan = (id) => {
  setRatePlans((prev) => (prev.length > 1 ? prev.filter((p) => p.id !== id) : prev));
};

// change a single field on one card
const handleRatePlanChange = (id, field, value) => {
  setRatePlans((prev) =>
    prev.map((p) => (p.id === id ? { ...p, [field]: value } : p))
  );
};

// toggle a boolean and optionally clear related prices
const handleRatePlanToggle = (id, field, checked) => {
  setRatePlans((prev) =>
    prev.map((p) => {
      if (p.id !== id) return p;
      const next = { ...p, [field]: checked };
      if (field === "hasCP" && !checked) next.cpBreakfast = "";
      if (field === "hasMAP" && !checked) {
        next.mapBreakfast = "";
        next.mapLunch = "";
      }
      if (field === "hasAP" && !checked) {
        next.apBreakfast = "";
        next.apLunch = "";
        next.apDinner = "";
      }
      return next;
    })
  );
};

// 🌐 OTA INFORMATION
const [otaInfo, setOtaInfo] = useState([
  {
    id: 1,
    otaName: "",
    propertyCode: "",
    otaUserName: "",
    otaPassword: "",
  },
]);

// Add new OTA info card
const addOtaInfo = () => {
  setOtaInfo((prev) => [
    ...prev,
    {
      id: Date.now(),
      otaName: "",
      propertyCode: "",
      otaUserName: "",
      otaPassword: "",
    },
  ]);
};

// Remove OTA info card
const removeOtaInfo = (id) => {
  setOtaInfo((prev) =>
    prev.length > 1 ? prev.filter((info) => info.id !== id) : prev
  );
};

// Handle field changes for each card
const handleOtaInfoChange = (id, field, value) => {
  setOtaInfo((prev) =>
    prev.map((info) =>
      info.id === id ? { ...info, [field]: value } : info
    )
  );
};


// 💸 EXTRA CHARGES
const [extraCharges, setExtraCharges] = useState([
  {
    id: 1,
    extraChargeName: "",
    extraChargePrice: "",
    extraPercentageCharged: "",
    extraChargesComments: "",
  },
]);

const addExtraCharge = () => {
  setExtraCharges((prev) => [
    ...prev,
    {
      id: Date.now(), // unique id for the row
      extraChargeName: "",
      extraChargePrice: "",
      extraPercentageCharged: "",
      extraChargesComments: "",
    },
  ]);
};

const removeExtraCharge = (id) => {
  setExtraCharges((prev) =>
    prev.length > 1 ? prev.filter((charge) => charge.id !== id) : prev
  );
};

// 🔑 The important bit: update a single row/field without touching others
const handleExtraChargeChange = (id, field, value) => {
  setExtraCharges((prev) =>
    prev.map((charge) =>
      charge.id === id ? { ...charge, [field]: value } : charge
    )
  );
};


// ✅ AmenityOption — handles chargable amenities
const AmenityOption = ({ label, name, formData, setFormData }) => {
  const chargeKey = `${name}Charges`;

  // initial values from formData (one time)
  const [checked, setChecked] = useState(
    formData[name] === "yes" || formData[name] === true
  );
  const [charge, setCharge] = useState(formData[chargeKey] || "");

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);

    // clear local charge if unchecked
    if (!isChecked) {
      setCharge("");
    }

    // keep whatever convention you like; here I’ll use "yes"/"no"
    setFormData((prev) => ({
      ...prev,
      [name]: isChecked ? "yes" : "no",
      [chargeKey]: isChecked ? (prev[chargeKey] || "") : "",
    }));
  };

  const handleChargeChange = (e) => {
    // let user type freely (no reset on each key)
    setCharge(e.target.value);
  };

  const handleChargeBlur = () => {
    // only sync to formData when user leaves the field
    setFormData((prev) => ({
      ...prev,
      [chargeKey]: charge,
    }));
  };

  return (
    <label style={{ display: "block", marginBottom: "12px" }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
      />{" "}
      {label}
      {checked && (
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder={`₹ ${label} Charges`}
          value={charge}
          onChange={handleChargeChange}
          onBlur={handleChargeBlur}
          style={{
            display: "block",
            marginTop: 8,
            width: 200,
            padding: 5,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
        />
      )}
    </label>
  );
};


// ✅ NoChargeAmenityOption — handles chargeless amenities
const NoChargeAmenityOption = ({ label, name, formData, setFormData }) => {
  const cleanKey = name.replace(/\s+/g, "");
  const checked = formData[cleanKey] === "yes";

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      [cleanKey]: isChecked ? "yes" : "no",
    }));
  };

  return (
    <label style={{ display: "block", marginBottom: "10px" }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />{" "}
      {label}
    </label>
  );
};

// GUIDELINES PAGE
  const renderStepContent = (step) => {
    if (step === 0) {
      return (
        <div className="guidelines-content">
          <p>The purpose of this Data Gathering Form is to collect all necessary information to help the RevX team configure the property in order to maintain the records.</p>
          <h3>Hotel / Property Information</h3>
          <ul>
            <li>The property information must belong to the hotel, and the contact information must be valid and functional. All future communications will be sent to the registered email address.</li>
            <li>Please ensure you fill in the property details accurately.</li>
            <li>For convenience, use the prefilled options in order to simply select and proceed.</li>
            <li>Ensure correct details are filled as the above details will be used during basic account setup, property configuration, OTA registration, and payment gateway registration.</li>
          </ul>
           <h3>Contact Information</h3>
          <ul>
            <li>Carefully enter the contact details for each category mentioned which are Owner, Manager and Billing person.</li>
            <li>Do mention the ownership/designation in order to avoid any further conflicts.</li>
          </ul>
          <h3>Documents uploading</h3>
          <ul>
            <li>Upload the documents properly under the fields mentioned on the page. Also note that Adhaar card & Pan card are mandatory.</li>
            <li>Ensure that the size limit is of 5 mb per file.</li>
            <li>If currently, some douments are under process of creation, then do mention the reasons and type of document remaining uder the comment's section.</li>
          </ul>
          <h3>Seasonal Trends Information</h3>
          <ul>
            <li>The one managing the property, you are the correct person who has knowledge about the market trends locally. Do mention the seasons.</li>
            <li>Using Ctrl and click, you can select multiple months or simply just drag it till where you want.</li>
          </ul>
           <h3>Facility Details</h3>
          <ul>
            <li>Go through facilities correctly in order to avoid conflicts.</li>
            <li>Under chargeable facilities, there is an option for free. When selecting 'Yes' under chargeable, do mention their rates respectively.</li>
          </ul>
          <h3>Room Type / Rate Plan Information</h3>
          <ul>
            <li>Enter the room type categories for your property as there are prefilled options too. Also, select the correct details accordingly.</li>
            <li>Specify the minimum and maximum occupancy for each room category.</li>
            <li>Enter the rate types available at your property (e.g., Room Only, Continental Plan, Half Board, Full Board).</li>
            <li>Provide the base rate for each room category, as well as additional charges for extra adults or children.</li>
            <li>Provide Room photographs in order to create a proper room category.</li>
            <li>Please tick the correct room level amenities. Also, there is a comment option to fill when need any guidance.</li>
            <li>You can only upload a maximum of 4 photos under the Room Photographs section.</li>
          </ul>
           <h3>Policies</h3>
          <ul>
            <li>Carefully read and then only choose from the mentioned options.</li>
            <li>In case of any problem, do mention it under the comment section below.</li>
          </ul>
          <h3>Payment Information</h3>
          <ul>
            <li>Under payment method, add the methods you use, using the '+' icon at top.</li>
            <li>Carefully fill the details, as before submitting, prefer crosschecking it twice.</li>
            <li>Attach cancelled cheque & payment qr documents carefully, as these will be used further for payment purposes.</li>
          </ul>
          <h3>OTA Channel</h3>
          <ul>
            <li>Select the Ota names either from the list or type manually on the given text area.</li>
            <li>Mention the property code, the username and the password correctly under each ota by adding it through the plus icon at top.</li>
          </ul>
          <h3>Credentials</h3>
          <ul>
            <li>Ensure you fill the passwords & links correctly.</li>
            <li>Correctly select the existence of social media.</li>
          </ul>
          <h3>Extra Charges Details</h3>
          <ul>
            <li>Mention properly the charges' names with their tax percentage if charged and their prices.</li>
            <li>Note: Extra Adult & Child rates fields are mentioned on the Rate plans page.</li>
          </ul>
          <h3>Frequently Asked Questions</h3>
          <ul>
            <li>This section includes all the possible questions that a guest can ask for.</li>
            <li>If you feel there are some more questions and answers, then do mention them under the comment section. </li>
          </ul>
          <h3>Overview</h3>
          <ul>
            <li>This section gives the complete overview of the documents and details you entered, so before submitting the form, do cross-check each detail thoroughly.</li>
          </ul>
          
          <br/>
          <form className="property-details-form"  onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
           <div style={{ gridColumn: "1 / -1" }}>
            <label>Have you read all the mentioned guidelines & ready to join RevX Hospitality!! <span style={{color:"red"}}>*</span></label>
            <textarea required rows="3" placeholder="For any query, type here..." name="guidelinesComment" value={formData.guidelinesComment} onChange={handleChange}/>
          </div></form>
        </div>
      );
    } 
    // PROPERTY DETAILS PAGE
     else if (step === 1) {
    return (
      
      <form className="property-details-form"  onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div className="form-grid">
          
          <div>
            <label>Property / Hotel Name <span style={{ color: "red" }}>*</span></label>
            <input type="text" name="propertyName" 
            value={formData.propertyName} onChange={handleChange} 
            placeholder="Enter Hotel Name" required />
          </div>
          <div>
  <label>Property Type <span style={{color:"red"}}>*</span></label>
  <input
    list="charge-options"
    placeholder="Select or enter Property Type" name="propertyType" value={formData.propertyType} onChange={handleChange} 
    style={{
      width: "100%",
      maxWidth: "100%",
      padding: "10px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px"
    }} required
  />
  <datalist id="charge-options">
    <option value="Apartment"/>
    <option value="Boutique Hotel"/>
    <option value="Cottage"/>
    <option value="Guest House"/>
    <option value="Homestay"/>
    <option value="Hostel"/>
    <option value="Hotel" />
    <option value="Motel"/>
    <option value="Office"/>
    <option value="Resort"/>
    <option value="Restaurant"/>
  </datalist>
</div>
          <div className="property_address">
            <label>Property Address <span style={{ color: "red" }}>*</span></label>
            <input type="text" placeholder="Enter Complete Address" name="PropertyAddress" value={formData.PropertyAddress} onChange={handleChange} required/>
          </div>
          <div>
            <label>Country <span style={{ color: "red" }}>*</span></label>
           <select name="country" value={formData.country} onChange={handleChange} required>
           <option value="" disabled selected>Select Country</option>
           <option value="India">India</option>
           <option value="USA">USA</option>
           <option value="Other">Other</option>
           </select>

          </div>
          <div>
            <label>Property State <span style={{ color: "red" }}>*</span></label>
            <select name="state" value={formData.state} onChange={handleChange} required>
              <option value="" disabled selected>Select State</option>
              <option>Andhra Pradesh</option>
              <option>Assam</option>
              <option>Bihar</option>
              <option>Chhattisgarh</option>
              <option>Delhi</option>
              <option>Goa</option>
              <option>Gujarat</option>
              <option>Haryana</option>
              <option>Himachal Pradesh</option>
              <option>Jharkhand</option>
              <option>Karnataka</option>
              <option>Kerala</option>
              <option>Madhya Pradesh</option>
              <option>Maharashtra</option>
              <option>Odisha</option>
              <option>Punjab</option>
              <option>Rajasthan</option>
              <option>Sikkim</option> 
              <option>Tamil Nadu</option>
              <option>Telangana</option>
              <option>Uttar Pradesh</option>
              <option>Uttarakhand</option>
              <option>West Bengal</option>
            </select>
          </div>
          <div>
            <label>Property City <span style={{ color: "red" }}>*</span></label>
            <select name="city" value={formData.city} onChange={handleChange} required>
              <option value="" disabled selected>Select City</option>
              <option>Agra</option>
<option>Ahmedabad</option>
<option>Aizawl</option>
<option>Ajmer</option>
<option>Alappuzha</option>
<option>Aligarh</option>
<option>Allahabad (Prayagraj)</option>
<option>Amritsar</option>
<option>Aurangabad</option>
<option>Ayodhya</option>
<option>Bangalore</option>
<option>Bareilly</option>
<option>Belgaum</option>
<option>Bhopal</option>
<option>Bhubaneswar</option>
<option>Bilaspur</option>
<option>Bokaro</option>
<option>Calicut</option>
<option>Chandigarh</option>
<option>Chennai</option>
<option>Coimbatore</option>
<option>Cuttack</option>
<option>Dalhousie</option>
<option>Darjeeling</option>
<option>Dehradun</option>
<option>Delhi</option>
<option>Dhanbad</option>
<option>Dharamshala</option>
<option>Dibrugarh</option>
<option>Durgapur</option>
<option>Dwarka</option>
<option>Ernakulam</option>
<option>Faridabad</option>
<option>Gandhinagar</option>
<option>Gangtok</option>
<option>Gaya</option>
<option>Ghaziabad</option>
<option>Goa</option>
<option>Gorakhpur</option>
<option>Guntur</option>
<option>Gurugram</option>
<option>Guwahati</option>
<option>Gwalior</option>
<option>Haridwar</option>
<option>Hisar</option>
<option>Hubli</option>
<option>Hyderabad</option>
<option>Imphal</option>
<option>Indore</option>
<option>Itanagar</option>
<option>Jabalpur</option>
<option>Jaipur</option>
<option>Jaisalmer</option>
<option>Jalandhar</option>
<option>Jammu</option>
<option>Jamshedpur</option>
<option>Jodhpur</option>
<option>Junagadh</option>
<option>Kanpur</option>
<option>Kanyakumari</option>
<option>Kochi</option>
<option>Kodaikanal</option>
<option>Kolkata</option>
<option>Kollam</option>
<option>Kollur</option>
<option>Kota</option>
<option>Kozhikode</option>
<option>Kullu</option>
<option>Lucknow</option>
<option>Ludhiana</option>
<option>Madurai</option>
<option>Manali</option>
<option>Mangalore</option>
<option>Manipur</option>
<option>Mathura</option>
<option>Meerut</option>
<option>Mumbai</option>
<option>Mussoorie</option>
<option>Mysuru</option>
<option>Nagpur</option>
<option>Nainital</option>
<option>Nashik</option>
<option>Noida</option>
<option>Ooty</option>
<option>Palakkad</option>
<option>Panipat</option>
<option>Panjim</option>
<option>Patna</option>
<option>Pondicherry</option>
<option>Prayagraj</option>
<option>Pune</option>
<option>Pushkar</option>
<option>Raipur</option>
<option>Rajkot</option>
<option>Ramnagar</option>
<option>Ranchi</option>
<option>Rishikesh</option>
<option>Roorkee</option>
<option>Salem</option>
<option>Shimla</option>
<option>Siliguri</option>
<option>Solapur</option>
<option>Srinagar</option>
<option>Surat</option>
<option>Thane</option>
<option>Thiruvananthapuram</option>
<option>Tiruchirappalli</option>
<option>Tirupati</option>
<option>Tirunelveli</option>
<option>Udaipur</option>
<option>Vadodara</option>
<option>Varanasi</option>
<option>Vijayawada</option>
<option>Visakhapatnam</option>
<option>Vrindavan</option>
<option>Warangal</option>

            </select>
          </div>
          
          <div>
            <label>Pin Code <span style={{ color: "red" }}>*</span></label>
<input type="number" name="pinCode" value={formData.pinCode} required
  onChange={(e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      handleChange(e);
    }
  }}
  inputMode="numeric" pattern="[0-9]*" placeholder="Enter Postal Code" onWheel={(e) => e.target.blur()} min="0"/>
          </div>
          
          <div>
            <label>Bill To Company / Organization <span style={{color:"red"}}>*</span></label>
            <input required type="text" name="bill" value={formData.bill} onChange={handleChange} placeholder="Enter" />
          </div>
          <div>
            <label>GST Number <span style={{ color: "red" }}>*</span></label>
            <input type="text" name="gst" value={formData.gst} onChange={handleChange} required class="gst-input" placeholder="Enter GST Number" maxlength="15" oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '')"/>
          </div>
          <div>
            <label>Reception Number <span style={{ color: "red" }}>*</span></label>
<input
  type="text"
  name="receptionNumber"
  value={formData.receptionNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleChange({ target: { name: "receptionNumber", value } });
    } }} required
  placeholder="Enter Phone Number"
  inputMode="numeric"
/>
          </div>
          <div>
            <label>Marketing no. (Google Page / Website) <span style={{color:"blue"}}>*</span></label>
            <input
  type="text"
  name="marketingNumber" 
  value={formData.marketingNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleChange({ target: { name: "marketingNumber", value } });
    } }}
  placeholder="Enter IVR Number"
  inputMode="numeric"
/>
          </div>
          <div>
            <label>Property Email<span style={{color:"red"}}>*</span></label>
            <input type="email" placeholder="Enter Property Email" name="propertyEmail" value={formData.propertyEmail} onChange={handleChange} required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address (e.g., name@example.com)"/>
          </div>
          <div>
            <label>Property Website URL <span style={{ color: "red" }}>*</span></label>
            <input type="url" placeholder="Paste URL here..." name="propertyWebsite" value={formData.propertyWebsite} onChange={handleChange}/>
          </div>
          <div>
            <label>Invoice Number reset?<span style={{color:"red"}}>*</span></label>
            <select name="invoiceNumber" value={formData.invoiceNumber} onChange={handleChange} required>
              <option value="" disabled selected>Select reset</option>
              <option>Yearly</option>
              <option>Monthly</option>
              <option>Never</option>
            </select>
          </div>
          <div>
            <label>Rates are Exclusive or Inclusive Taxes? <span style={{ color: "red" }}>*</span></label>
            <select name="ratesAre" value={formData.ratesAre} onChange={handleChange} required>
              <option value="" disabled selected>Select Tax type</option>
              <option>Exclusive Taxes</option>
              <option>Inclusive Taxes</option>
            </select>
          </div>
          <div>
            <label>Star Category <span style={{ color: "red" }}>*</span></label>
            <select name="starCategory" value={formData.starCategory} onChange={handleChange} required>
              <option value="" disabled selected>Select Star Category</option>
              <option>1 Star</option>
              <option>2 Star</option>
              <option>3 Star</option>
              <option>4 Star</option>
              <option>5 Star</option>
              <option>6 Star</option>
              <option>7 Star</option>
            </select>
          </div>
          <div>
            <label>Import Future Bookings? <span style={{color:"blue"}}>*</span></label>
            <select name="importFuture" value={formData.importFuture} onChange={handleChange}>
              <option value="" disabled selected>Select</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          </div>

          <h4>Check-In / Out Details </h4><br/>
          <div>
  <label>Check-In Time <span style={{color:"red"}}>*</span></label>
  <input
    list="checkin-options"
    placeholder="Enter time" name="checkIn" value={formData.checkIn} onChange={handleChange} required
    style={{
      width: "100%",
      maxWidth: "100%",
      padding: "10px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px"
    }}
  />
  <datalist id="checkin-options">
              <option>10:00 AM</option>
              <option>11:00 AM</option>
              <option>12:00 PM</option>
              <option>01:00 PM</option>
              <option>02:00 PM</option>
  </datalist>
</div>
          <div>
           <label>Check-Out Time <span style={{color:"red"}}>*</span></label>
           <input
            list="checkout-options"
            placeholder="Enter time" name="checkOut" value={formData.checkOut} onChange={handleChange} required
            style={{
            width: "100%",
            maxWidth: "100%",
           padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px"
             }}
            />
            <datalist id="checkout-options">
              <option>10:00 AM</option>
              <option>11:00 AM</option>
              <option>12:00 PM</option>
              <option>01:00 PM</option>
              <option>02:00 PM</option>
            </datalist>
          </div>
            <h4>Building Info</h4><br/>
            <div>
           <label>Total floors (excl. underground floors) <span style={{ color: "red" }}>*</span></label>
           <input
            list="floor-options"
            placeholder="Enter number of floors" name="buildingFloors" value={formData.buildingFloors} onChange={handleChange} required
            style={{
            width: "100%",
            maxWidth: "100%",
           padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px"
             }}
            />
            <datalist id="floor-options">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
            </datalist>
          </div>
          <div>
            <label>Total number of rooms available at the property <span style={{ color: "red" }}>*</span></label>
            <input type="number" min={0} placeholder="Enter number of rooms" name="buildingRooms" value={formData.buildingRooms} onChange={handleChange} required/>
          </div>
          
          
          <div style={{ gridColumn: "1 / -1" }}>
            <label>If you want to provide additional information...</label>
            <textarea rows="3" placeholder="Enter additional details here..." name="propertyComments" value={formData.propertyComments} onChange={handleChange}/>
          </div>
        </div>
        {/* <div className="step-buttons"> <button type="submit">Submit</button></div> */}
      </form>
    );
  // CONTACT DETAILS PAGE
  } else if (step === 2) {
    return (
      <form className="contact-person-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div className="form-grid">
          <div><h4>Owner Details</h4></div><br/>
         <div> 
  <label>
    Contact Person Name <span style={{ color: "red" }}>*</span>
  </label>
  <input 
    type="text" 
    placeholder="Enter Your Name" name="ownerContactName" value={formData.ownerContactName} onChange={handleChange}
    required 
  />
</div>
          <div>
            <label>
  Designation <span style={{ color: "red" }}>*</span>
</label>
<input
  list="owner-designation-options"
  name="ownerDesignation"
  value={formData.ownerDesignation}
  onChange={handleChange}
  placeholder="Select or enter Designation"
  required
  style={{
    width: "100%",
    maxWidth: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px",
  }}
/>

<datalist id="owner-designation-options">
  <option value="Owner" />
  <option value="Owner (Lease Property)"/>
  <option value="Partner" />
  <option value="Brother of Owner" />
  <option value="Sister of Owner" />
  <option value="Manager" />
  <option value="General Manager" />
  <option value="Director" />
  <option value="Other" />
</datalist>


          </div>
          <div>
            <label>Date of Birth</label>
            <input
              type="date"
              name="ownerDOB"
              value={formData.ownerDOB}
              onChange={handleChange}
              style={{
                width: "100%",
                maxWidth: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
          </div>
          <div>
            <label>State/City of Owner</label>
            <input
              type="text"
              placeholder="Enter state/city"
              name="ownerStateCity"
              value={formData.ownerStateCity}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Email Address <span style={{ color: "red" }}>*</span></label>
            <input type="email" placeholder="Enter mail id" name="ownerEmail" value={formData.ownerEmail} onChange={handleChange} required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address (e.g., name@example.com)"/>
          </div>
          <div>
            <label>Mobile Number <span style={{ color: "red" }}>*</span></label>
          <input
  type="text"
  name="ownerMobileNumber"
  value={formData.ownerMobileNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleChange({ target: { name: "ownerMobileNumber", value } });
    } }} required
  placeholder="Enter mobile number"
  inputMode="numeric"
/>
          </div>
          <div><h4>Manager Details</h4></div><br/>
          <div>
            <label>Contact Person Name <span style={{ color: "red" }}>*</span></label>
            <input type="text" placeholder="Enter name" name="managerContactName" value={formData.managerContactName} onChange={handleChange} required/>
          </div>
          <div>
            <label>
  Designation <span style={{ color: "red" }}>*</span>
</label>

<input
  list="manager-designation-options"
  name="managerDesignation"
  value={formData.managerDesignation}
  onChange={handleChange}
  placeholder="Select or enter Designation"
  required
  style={{
    width: "100%",
    maxWidth: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px"
  }}
/>

<datalist id="manager-designation-options">
  <option value="Front Office Manager" />
  <option value="General Manager" />
  <option value="Manager" />
  <option value="Managing Director" />
  <option value="Operations Manager" />
  <option value="Reservation Executive" />
</datalist>

          </div>
          <div>
            <label>Email Address <span style={{ color: "red" }}>*</span></label>
            <input type="email" placeholder="Enter mail id" name="managerEmail" value={formData.managerEmail} onChange={handleChange} required/>
          </div>
          <div>
            <label>Mobile Number <span style={{ color: "red" }}>*</span></label>
          <input
  type="text"
  name="managerMobileNumber"
  value={formData.managerMobileNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleChange({ target: { name: "managerMobileNumber", value } });
    } }} required
  placeholder="Enter mobile number"
  inputMode="numeric"
/>
          </div>
          <div><h4>Billing / Invoice related matters</h4></div><br/>
          <div>
            <label>Contact Person Name <span style={{color:"blue"}}>*</span></label>
            <input type="text" placeholder="Enter name" name="billingContactName" value={formData.billingContactName} onChange={handleChange} />
          </div>
          <div>
            <label>Designation <span style={{color:"blue"}}>*</span></label>
            <input type="text" placeholder="Enter here" name="billingDesignation" value={formData.billingDesignation} onChange={handleChange} />
          </div>
          <div>
            <label>Email Address <span style={{color:"blue"}}>*</span></label>
            <input type="email" placeholder="Enter mail id" name="billingEmail" value={formData.billingEmail} onChange={handleChange} />
          </div>
          <div>
            <label>Mobile Number <span style={{color:"blue"}}>*</span></label>
          <input
  type="text"
  name="billingMobileNumber"
  value={formData.billingMobileNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleChange({ target: { name: "billingMobileNumber", value } });
    } }} 
  placeholder="Enter mobile number"
  inputMode="numeric"
/>
          </div>
        </div>
      </form>
    );
      
  // DOCUMENTS PAGE
  } else if (step === 3) {
  return (
    <form className="room-type-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div className="form-grid">
      <h4 className="form-heading">Hotel Documents</h4><br/>
{/* ✅ GST Certificate Upload */}
<div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="gstCertificate" className="upload-label">
    GST Certificate <span style={{ color: "red" }}>*</span>
  </label>
  <input
  type="file"
  required
  id="gstCertificate"
  name="gstCertificate"
  accept=".pdf"
  className="file-input"
  onChange={(e) => {
    const file = e.target.files[0];
    const previewContainer = document.getElementById("gstPreviewContainer");
    previewContainer.innerHTML = "";
    if (!file) return;

    if (file.size >1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}


    // ✅ store the actual File object
    setFormData((prev) => ({
      ...prev,
      gstCertificate: file,
    }));

    const fileURL = URL.createObjectURL(file);

    if (file.type === "application/pdf") {
      const iframe = document.createElement("iframe");
      iframe.src = fileURL;
      iframe.style.width = "100%";
      iframe.style.height = "300px";
      iframe.style.border = "1px solid #ccc";
      iframe.style.borderRadius = "8px";
      previewContainer.appendChild(iframe);
    } else if (file.type.startsWith("image/")) {
      const img = document.createElement("img");
      img.src = fileURL;
      img.alt = "GST Certificate";
      img.style.width = "150px";
      img.style.height = "150px";
      img.style.objectFit = "cover";
      img.style.border = "1px solid #ccc";
      img.style.borderRadius = "8px";
      previewContainer.appendChild(img);
    } else {
      const link = document.createElement("a");
      link.href = fileURL;
      link.textContent = "View Uploaded File";
      link.target = "_blank";
      previewContainer.appendChild(link);
    }
  }}
/>

  <small style={{ color: "gray", fontSize: "12px" }}>Accepted formats: PDF (max size: 1MB)</small>
  {/* Preview Container */}
  <div
    id="gstPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div>
{/* ✅ Lease/Rent Agreement Upload */}
<label style={{ display: "block", marginBottom: "10px" }}>
  <input
    type="checkbox"
    checked={formData.hasLeaseAgreement}
    onChange={(e) =>
      setFormData({
        ...formData,
        hasLeaseAgreement: e.target.checked,
        leaseAgreement: "", // clear file name when unchecked
      })
    }
  /> 
  Lease / Rent Agreement <span style={{color:"blue"}}>*</span>
</label>

{formData.hasLeaseAgreement && (
  <div className="document-upload-section" style={{ marginBottom: "20px" }}>
    <label htmlFor="leaseAgreement" className="upload-label">
      Upload Lease / Rent Agreement Document <span style={{color:"red"}}>*</span>
    </label>

    <input
      type="file"
      id="leaseAgreement"
      name="leaseAgreement"
      accept=".pdf"
      className="file-input"
      required     // ⬅️ only required when visible
      onChange={(e) => {
        const file = e.target.files[0];
        const previewContainer = document.getElementById(
          "leasePreviewContainer"
        );
        previewContainer.innerHTML = "";

        if (!file) return;

        // Save file name to formData
        setFormData((prev) => ({
  ...prev,
  leaseAgreement: file,
}));


       if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}


        const fileURL = URL.createObjectURL(file);

        if (file.type === "application/pdf") {
          const iframe = document.createElement("iframe");
          iframe.src = fileURL;
          iframe.style.width = "100%";
          iframe.style.height = "300px";
          iframe.style.border = "1px solid #ccc";
          iframe.style.borderRadius = "8px";
          previewContainer.appendChild(iframe);
        } else if (file.type.startsWith("image/")) {
          const img = document.createElement("img");
          img.src = fileURL;
          img.alt = "Lease Agreement";
          img.style.width = "150px";
          img.style.height = "150px";
          img.style.objectFit = "cover";
          img.style.border = "1px solid #ccc";
          img.style.borderRadius = "8px";
          previewContainer.appendChild(img);
        } else {
          const link = document.createElement("a");
          link.href = fileURL;
          link.textContent = "View Uploaded File";
          link.target = "_blank";
          previewContainer.appendChild(link);
        }
      }}
    />

    <small style={{ color: "gray", fontSize: "12px" }}>
      Accepted formats: PDF (max size: 1MB)
    </small>

    {/* Preview Container */}
    <div
      id="leasePreviewContainer"
      style={{
        marginTop: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    ></div>
  </div>
)}


      <div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="msmeDocument" className="upload-label">
    MSME <span style={{color: 'blue'}}>*</span></label>
  <input
    type="file"
    id="msmeDocument"
    name="msmeDocument" 
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("msmePreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

// ✅ MSME Document
setFormData((prev) => ({
  ...prev,
  msmeDocument: file,
}));


     if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        // Display PDF preview
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        // Display image preview
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        // Unsupported format fallback
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}
  />
  <small style={{ color: "gray", fontSize: "12px" }}>Accepted formats: PDF, JPG, PNG (max size: 1MB)</small>
  {/* Preview container */}
  <div
    id="msmePreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div> 
<div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="letterHead" className="upload-label">
    Letterhead <span style={{color: 'blue'}}>*</span>
  </label>
  <input
    type="file"
    id="letterHead"
    name="letterHead" 
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("letterPreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

      // ✅ Letterhead
setFormData((prev) => ({
  ...prev,
  letterHead: file,
}));


      if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        // Display PDF preview
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        // Display image preview
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        // Unsupported format fallback
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}/>
  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF (max size: 1MB)
  </small>
  {/* Preview container */}
  <div
    id="letterPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div>
      <div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="gstDocument" className="upload-label">
    Utility Bill (Electricty, Mobile, Gas bill, etc.) <span style={{color: 'blue'}}>*</span>
  </label>
  <input
    type="file"
    id="utilityBill"
    name="utilityBill" 
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("utilityPreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

      // ✅ Utility Bill
setFormData((prev) => ({
  ...prev,
  utilityBill: file,
}));


     if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        // Display PDF preview
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        // Display image preview
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        // Unsupported format fallback
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}/>
  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF (max size: 1MB)
  </small>
  {/* Preview container */}
  <div
    id="utilityPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div> 
      <div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="gstDocument" className="upload-label">
    Aadharcard <span style={{color: 'red'}}>*</span>
  </label>
  <input
    type="file"
    id="aadhaarCard" required
    name="aadhaarCard" 
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("adharPreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

      // ✅ Aadhaar Card
setFormData((prev) => ({
  ...prev,
  aadhaarCard: file,
}));


      if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        // Display PDF preview
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        // Display image preview
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        // Unsupported format fallback
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}/>
  <small style={{ color: "gray", fontSize: "12px" }}>Accepted formats: PDF (max size: 1MB)</small>
  {/* Preview container */}
  <div
    id="adharPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div>  
      <div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="gstDocument" className="upload-label">
    Pan card <span style={{color: 'red'}}>*</span>
  </label>
  <input
    type="file"
    id="panCard" required
    name="panCard" 
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("panPreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

      // ✅ PAN Card
setFormData((prev) => ({
  ...prev,
  panCard: file,
}));


     if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        // Display PDF preview
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        // Display image preview
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        // Unsupported format fallback
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}/>
  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF (max size: 1MB)
  </small>
  {/* Preview container */}
  <div
    id="panPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div>    
<div className="document-upload-section" style={{ marginBottom: "20px" }}>
  <label htmlFor="gstDocument" className="upload-label">
    Other Documents <span style={{ color: "blue" }}>*</span>
  </label>
  <input
    type="file"
    id="otherDocument"
    name="otherDocument"
    accept=".pdf"
    className="file-input"
    onChange={(e) => {
      const file = e.target.files[0];
      const previewContainer = document.getElementById("otherPreviewContainer");
      previewContainer.innerHTML = ""; // Clear previous previews
      if (!file) return;

      // ✅ Other Documents
setFormData((prev) => ({
  ...prev,
  otherDocument: file,
}));


      if (file.size > 1 * 1024 * 1024) {  // 500 KB limit
  alert("❌ File size exceeds 1MB limit.");
  e.target.value = "";
  return;
}

      const fileURL = URL.createObjectURL(file);
      if (file.type === "application/pdf") {
        const iframe = document.createElement("iframe");
        iframe.src = fileURL;
        iframe.style.width = "100%";
        iframe.style.height = "300px";
        iframe.style.border = "1px solid #ccc";
        iframe.style.borderRadius = "8px";
        previewContainer.appendChild(iframe);
      } else if (file.type.startsWith("image/")) {
        const img = document.createElement("img");
        img.src = fileURL;
        img.alt = "Uploaded Document";
        img.style.width = "150px";
        img.style.height = "150px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #ccc";
        img.style.borderRadius = "8px";
        previewContainer.appendChild(img);
      } else {
        const link = document.createElement("a");
        link.href = fileURL;
        link.textContent = "View Uploaded File";
        link.target = "_blank";
        link.style.display = "block";
        link.style.marginTop = "10px";
        previewContainer.appendChild(link);
      }
    }}
  />
  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF (max size: 1MB)
  </small>
{/* Preview container */}
  <div
    id="otherPreviewContainer"
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  ></div>
</div>

<div style={{ gridColumn: "1 / -1" }}>
            <label>Please Mention reason for not attaching other documents <span style={{color:"blue"}}>*</span></label>
            <textarea rows="3" placeholder="Enter reason here if not attached else type NA..." name="documentComments" value={formData.documentComments} onChange={handleChange}/>
          </div> </div>
           {/* <div className="step-buttons"> <button type="submit">Submit</button></div> */}
    </form> 
  );
}
  
// PROPERTY SEASONS PAGE
else if (step === 4) {
  return (
    <form className="room-type-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
         {/* PEAK SEASONS */}
       {/* PEAK SEASONS */}
<div className="amenity-group">
  <h3>Peak Seasons</h3>
  <div className="seaons-group">
    <select
      multiple
      className="multi-select"
      name="peakSeasons"
      value={formData.peakSeasons}
      onChange={handleChange}
    >
      {[
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
      ].map((month) => (
        <option key={month} value={month}  className={formData.peakSeasons.includes(month) ? "peak-selected" : ""}>
          {month}
        </option>
      ))}
    </select>
  </div>
</div>
<small>'Ctrl + Click' or 'Drag + Click'</small>


{/* MID SEASONS */}
<div className="amenity-group">
  <h3>Mid Seasons</h3>
  <div className="seasons-group">
    <select
      multiple
      className="multi-select"
      name="midSeasons"
      value={formData.midSeasons}
      onChange={handleChange}
    >
      {[
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
      ].map((month) => (
        <option
          key={month}
          value={month}
          className={formData.midSeasons.includes(month) ? "mid-selected" : ""}
        >
          {month}
        </option>
      ))}
    </select>
  </div>
</div>
<small>'Ctrl + Click' or 'Drag + Click'</small>


{/* LOW SEASONS */}
<div className="amenity-group">
  <h3>Low Seasons</h3>
  <div className="seaons-group">
    <select
      multiple
      className="multi-select"
      name="lowSeasons"
      value={formData.lowSeasons}
      onChange={handleChange}
    >
      {[
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
      ].map((month) => (
        <option
          key={month}
          value={month}
          className={formData.lowSeasons.includes(month) ? "low-selected" : ""}
        >
          {month}
        </option>
      ))}
    </select>
  </div>
</div>
<small>'Ctrl + Click' or 'Drag + Click'</small><br/>
<div style={{ gridColumn: "1 / -1" }}>
            <label>Please mention whatever you know about market trends <span style={{color:'blue'}}>*</span></label>
            <textarea rows="3" placeholder="Enter details here else type NA..." name="seasonalTrendsComments" value={formData.seasonalTrendsComments} onChange={handleChange}/>
          </div>

        {/* <div className="step-buttons"> <button type="submit">Submit</button></div> */}
    </form>
  );
}
// FACILITIES PAGE
else if (step === 5) {
  return (
   <form  
  className="room-type-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <div className="amenities-section">
    {/* Facilities */}
    <div className="amenity-group">
      <h3>
        Most Popular Facilities <span style={{ color: "red" }}>*</span>
      </h3>
      <div className="amenity-options">
        <h4>Chargeless</h4>
        <br />
        <NoChargeAmenityOption
        key="Restaurant" 
          label="Restaurant"
          name="Restaurant"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="Terrace"
          label="Terrace"
          name="Terrace"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="Lift"
          label="Lift"
          name="Lift"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="Wifi"
          label="WiFi"
          name="WiFi"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="TwentyFourService"
          label="Twenty Four Service"
          name="TwentyFourService"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="AirConditioner"
          label="Air Conditioner"
          name="AirConditioner"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="Garden"
          label="Garden"
          name="Garden"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="RoomService"
          label="Room Service"
          name="RoomService"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="Bar"
          label="Bar"
          name="Bar"
          formData={formData}
          setFormData={setFormData}
        />
        <br />
        <h4>Chargable</h4>
        <br />
        
        <AmenityOption
        key="Sauna"
          label="Sauna"
          name="Sauna"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="AirportShuttle"
          label="Airport Shuttle"
          name="AirportShuttle"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Jacuzzi"
          label="Jacuzzi"
          name="Jacuzzi"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="WaterPark"
          label="Water Park"
          name="WaterPark"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Spa"
          label="Spa"
          name="Spa"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Parking"
          label="Parking"
          name="Parking"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="FacilityforDisabled"
          label="Facility for Disabled"
          name="FacilityforDisabled"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="GameRoom"
          label="Game Room"
          name="GameRoom"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="PrivateTaxi"
          label="Private Taxi"
          name="PrivateTaxi"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Pool Amenities */}
    <div className="amenity-group">
      <h3>
        Pool Amenities <span style={{ color: "red" }}>*</span>
      </h3>
      <br />
      <div className="amenity-options">
        <h4>Chargeless</h4>
        <br />
        <NoChargeAmenityOption
        key="PoolCover"
          label="Pool Cover"
          name="PoolCover"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="PoolTowels"
          label="Pool Towels"
          name="PoolTowels"
          formData={formData}
          setFormData={setFormData}
        />
        <h4>Chargable</h4>
        <br />
        <AmenityOption
        key="PrivatePool"
          label="Private Pool"
          name="PrivatePool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="HeatedPool"
          label="Heated Pool"
          name="HeatedPool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="InfinityPool"
          label="Infinity Pool"
          name="InfinityPool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="PlungePool"
          label="Plunge Pool"
          name="PlungePool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="PoolWithView"
          label="Pool With View"
          name="PoolWithView"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="RoofTopPool"
          label="Roof Top Pool"
          name="RoofTopPool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="SaltWaterPool"
          label="Salt Water Pool"
          name="SaltWaterPool"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="KidsPool"
          label="Kids Pool"
          name="KidsPool"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Indoor Swimming Pool */}
    <div className="amenity-group">
      <h3>Indoor Swimming Pool</h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="OpenAllYear"
          label="Open All Year"
          name="OpenAllYear"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="AllAgesWelcome"
          label="All Ages Welcome"
          name="AllAgesWelcome"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="IndoorPoolWithView"
          label="Indoor Pool With View"
          name="IndoorPoolWithView"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Reception Services */}
    <div className="amenity-group">
      <h3>Reception Services</h3>
      <div className="amenity-options">
        <h4>Chargeless</h4>
        <br />
        <NoChargeAmenityOption
        key="InvoiceProvided"
          label="Invoice Provided"
          name="InvoiceProvided"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="TourDesk"
          label="Tour Desk"
          name="TourDesk"
          formData={formData}
          setFormData={setFormData}
        />
        <h4>Chargable</h4>
        <br />
        <AmenityOption
        key="Lockers"
          label="Lockers"
          name="Lockers"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="LuggageStorage"
          label="Luggage Storage"
          name="LuggageStorage"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Outdoor Features */}
    <div className="amenity-group">
      <h3>Outdoor Features</h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="OutdoorFurniture"
          label="Outdoor Furniture"
          name="OutdoorFurniture"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="SunTerrace"
          label="Sun Terrace"
          name="SunTerrace"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Activities */}
    <div className="amenity-group">
      <h3>Activities</h3>
      <div className="amenity-options">
        <AmenityOption
        key="BicycleRental"
          label="Bicycle Rental"
          name="BicycleRental"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="WalkingTours"
          label="Walking Tours"
          name="WalkingTours"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Darts"
          label="Darts"
          name="Darts"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="IndoorPlayArea"
          label="Indoor Play Area"
          name="IndoorPlayArea"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="BoardGamesPuzzles"
          label="Board Games Puzzles"
          name="BoardGamesPuzzles"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="EveningEntertainment"
          label="Evening Entertainment"
          name="EveningEntertainment"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="LiveMusicPerformance"
          label="Live Music Performance"
          name="LiveMusicPerformance"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="TableTennis"
          label="Table Tennis"
          name="TableTennis"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Billiards"
          label="Billiards"
          name="Billiards"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Bonfire"
          label="Bonfire"
          name="Bonfire"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Food & Drinks */}
    <div className="amenity-group">
      <h3>Food & Drinks</h3>
      <div className="amenity-options">
        <AmenityOption
        key="SnackBar"
          label="Snack Bar"
          name="SnackBar"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Wine"
          label="Wine"
          name="Wine"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Fruits"
          label="Fruits"
          name="Fruits"
          formData={formData}
          setFormData={setFormData}
        />
        <AmenityOption
        key="Snacks"
          label="Snacks"
          name="Snacks"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Cleaning Services */}
    <h3>Cleaning Services *</h3>
    <div className="amenity-options">
      <NoChargeAmenityOption
      key="DailyHousekeeping"
        label="Daily Housekeeping"
        name="DailyHousekeeping"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="IroningServices"
        label="Ironing Services"
        name="IroningServices"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="Laundry"
        label="Laundry"
        name="Laundry"
        formData={formData}
        setFormData={setFormData}
      />
    </div>

    {/* Wellness */}
    <h3>Wellness</h3>
    <div className="amenity-options">
      <AmenityOption
      key="YogaClasses"
        label="Yoga Classes"
        name="YogaClasses"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="Fitness"
        label="Fitness"
        name="Fitness"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="SpaFacilities"
        label="Spa Facilities"
        name="SpaFacilities"
        formData={formData}
        setFormData={setFormData}
      />
    </div>

    {/* Business Facilities */}
    <h3>Business Facilities</h3>
    <div className="amenity-options">
      <AmenityOption
      key="FaxPhotocopying"
        label="Fax Photocopying"
        name="FaxPhotocopying"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="BusinessCenter"
        label="Business Center"
        name="BusinessCenter"
        formData={formData}
        setFormData={setFormData}
      />
      <AmenityOption
      key="MeetingBanquetRooms"
        label="Meeting Banquet Rooms"
        name="MeetingBanquetRooms"
        formData={formData}
        setFormData={setFormData}
      />
    </div>

    {/* Safety and Security */}
    <div className="amenity-group">
      <h3>Safety and Security</h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="FireExtinguisher"
        label="Fire Extinguisher"
        name="FireExtinguisher"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="CctvOutsideProperty"
        label="Cctv Outside Property"
        name="CctvOutsideProperty"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="CctvinCommonAreas"
        label="Cctv in Common Areas"
        name="CctvinCommonAreas"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="SmokeAlarm"
        label="Smoke Alarm"
        name="SmokeAlarm"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="SecurityAlarm"
        label="Security Alarm"
        name="SecurityAlarm"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="KeyCardAccess"
        label="Key Card Access"
        name="KeyCardAccess"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="TwentyFourSecurity"
        label="Twenty Four Security"
        name="TwentyFourSecurity"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="SafetyDepositBox"
        label="Safety Deposit Box"
        name="SafetyDepositBox"
        formData={formData}
        setFormData={setFormData}
      />
      </div>
    </div>

    {/* General */}
    <div className="amenity-group">
      <h3>
        General <span style={{ color: "red" }}>*</span>
      </h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="SharedLoungeTVArea"
        label="Shared Lounge TV Area"
        name="SharedLoungeTVArea"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="DesignatedSmokingArea"
        label="Designated Smoking Area"
        name="DesignatedSmokingArea"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="TileMarbleFloor"
        label="Tile Marble Floor"
        name="TileMarbleFloor"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="Soundproofing"
        label="Soundproofing"
        name="Soundproofing"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="Fan"
        label="Fan"
        name="Fan"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="FamilyRooms"
        label="Family Rooms"
        name="FamilyRooms"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="SmokingAllowed"
        label="Smoking allowed"
        name="SmokingAllowed"
        formData={formData}
        setFormData={setFormData}
      />
      <NoChargeAmenityOption
      key="SmokingNotAllowed"
        label="Smoking not allowed"
        name="SmokingNotAllowed"
        formData={formData}
        setFormData={setFormData}
      />
      </div>
    </div>

    {/* Accessibility */}
    <div className="amenity-group">
      <h3>
        Accessibility <span style={{ color: "red" }}>*</span>
      </h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="WheelchairAccessible"
          label="Wheelchair Accessible"
          name="WheelchairAccessible"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="UpperFloorsAccessiblebyElevator"
          label="Upper Floors Accessible by Elevator"
          name="UpperFloorsAccessiblebyElevator"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Languages */}
    <div className="amenity-group">
      <h3>Languages Spoken</h3>
      <div className="amenity-options">
        <NoChargeAmenityOption
        key="Hindi"
          label="Hindi"
          name="Hindi"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="English"
          label="English"
          name="English"
          formData={formData}
          setFormData={setFormData}
        />
        <NoChargeAmenityOption
        key="LocalLanguage"
          label="Local Language"
          name="LocalLanguage"
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>

    {/* Additional Info */}
    <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
      <label>Please crosscheck once and then type NA <span style={{color:'red'}}>*</span></label>
      <textarea
        rows="3" required
        className="textarea-input"
        placeholder="Did we miss any amenity? Don't worry mention it here else type NA..."
        name="facilitiesComments"
        value={formData.facilitiesComments}
        onChange={handleChange}
      />
    </div>
  </div> 
</form>

  );
}
// ROOM TYPE PAGE
else if (step === 6) {
  return (
    <form className="room-type-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p>Please define all Room Types you have in your property</p>
      {roomTypes.map((room, index) => (
  <div className="room-type-card" key={room.id}>
    <div className="room-type-header">
      <h4>Room Type {index + 1}</h4>
      <div className="room-type-actions">
        <button type="button" onClick={addRoomType}>+</button>
        <button type="button" onClick={() => removeRoomType(room.id)}>-</button>
      </div>
    </div>

    <div className="form-grid">
      {/* Name */}
      <div>
        <label>Room Type Name <span style={{color:"red"}}>*</span></label>
        <input
          list="room-type-options"
          placeholder="Select or type room type"
          value={room.name}
          onChange={(e) => handleRoomTypeChange(room.id, "name", e.target.value)}
          required
          style={{ width:"92.5%", maxWidth:"100%", padding:"10px", borderRadius:"8px", border:"1px solid #ccc", fontSize:"14px" }}
        />
        <datalist id="room-type-options">
          <option>Standard Room</option>
          <option>Standard Double Room</option>
          <option>Deluxe Room</option>
          <option>Deluxe Double Room</option>
          <option>Super Deluxe Room</option>
          <option>Family Room</option>
        </datalist>
      </div>

      {/* Bed Type */}
      <div>
        <label>Bed type <span style={{color:"red"}}>*</span></label>
        <select
          value={room.bedType}
          onChange={(e) => handleRoomTypeChange(room.id, "bedType", e.target.value)}
          required
        >
          <option value="">Select</option>
          <option value="King Size">King Size</option>
          <option value="Queen">Queen</option>
          <option value="Double">Double</option>
          <option value="Twin">Twin</option>
          <option value="Single">Single</option>
        </select>
      </div>

      {/* Size */}
      <div>
        <label>Room size <span style={{color:"red"}}>*</span></label>
        <input
  type="number"
  placeholder="Enter room size"
  min="0"
  value={room.roomSize?.replace(" sqft", "")}
  onChange={(e) =>
    handleRoomTypeChange(room.id, "roomSize", e.target.value + " sqft")
  }
  required
/>

      </div>

      {/* Numbers */}
      <div>
        <label>Room Numbers <span style={{color:"red"}}>*</span></label>
        <input
          type="text"
          placeholder="Enter room num (e.g. 101, 102A)"
          value={room.roomNumbers}
          onChange={(e) => handleRoomTypeChange(room.id, "roomNumbers", e.target.value)}
          required
        />
        <small style={{ color: "gray", fontSize: "12px" }}>
          Separate multiple room numbers with commas.
        </small>
      </div>

      {/* Beds count */}
      <div>
        <label>Beds count per room <span style={{color:"red"}}>*</span></label>
        <input
          type="number"
          min="0"
          placeholder="Enter number of beds per room"
          value={room.bedsCountPerRoom}
          onChange={(e) => handleRoomTypeChange(room.id, "bedsCountPerRoom", e.target.value)}
          required
        />
      </div>

      {/* Occupancy */}
      <div>
        <label>Base Adult <span style={{color:"red"}}>*</span></label>
        <select
          value={room.baseAdult}
          onChange={(e) => handleRoomTypeChange(room.id, "baseAdult", e.target.value)}
          required
        >
          <option value="" disabled>Select Base Adult</option>
          <option>1</option><option>2</option><option>3</option><option>4</option><option>5</option>
        </select>
      </div>

      <div>
        <label>Max Adult <span style={{color:"red"}}>*</span></label>
        <select
          value={room.maxAdult}
          onChange={(e) => handleRoomTypeChange(room.id, "maxAdult", e.target.value)}
          required
        >
          <option value="" disabled>Select Max Adult</option>
          <option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option>
        </select>
      </div>

      <div>
        <label>Base Child <span style={{color:"red"}}>*</span></label>
        <select
          value={room.baseChild}
          onChange={(e) => handleRoomTypeChange(room.id, "baseChild", e.target.value)}
          required
        >
          <option value="" disabled>Select Base Child</option>
          <option>1</option><option>2</option><option>3</option><option>4</option><option>5</option>
        </select>
      </div>

      <div>
        <label>Max Child <span style={{color:"red"}}>*</span></label>
        <select
          value={room.maxChild}
          onChange={(e) => handleRoomTypeChange(room.id, "maxChild", e.target.value)}
          required
        >
          <option value="" disabled>Select Max Child</option>
          <option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option>
        </select>
      </div>

      <div>
        <label>Max Occupancy <span style={{color:"red"}}>*</span></label>
        <select
          value={room.maxOccupancy}
          onChange={(e) => handleRoomTypeChange(room.id, "maxOccupancy", e.target.value)}
          required
        >
          <option value="" disabled>Select Max Occupancy</option>
          <option>2</option><option>3</option><option>4</option>
          <option>5</option><option>6</option><option>7</option><option>8</option><option>9</option><option>10</option>
        </select>
      </div>

      <div>
        <label>
  Room Inventory <span style={{ color: "red" }}>*</span>
</label>

<input
  list={`room-inventory-options-${room.id}`}
  value={room.roomInventory}
  onChange={(e) =>
    handleRoomTypeChange(room.id, "roomInventory", e.target.value)
  }
  placeholder="Select or enter Room Inventory"
  required
  inputMode="numeric"
  pattern="[0-9]*"
  style={{
    width: "92.5%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px"
  }}
/>

<datalist id={`room-inventory-options-${room.id}`}>
  <option value="1" />
  <option value="2" />
  <option value="3" />
  <option value="4" />
  <option value="5" />
  <option value="6" />
</datalist>

      </div>

      {/* Thresholds */}
      <div>
        <label>Min Rate Threshold <span style={{color:"red"}}>*</span></label>
        <input
          type="number" min="0" placeholder="Enter Minimum rate you can do"
          value={room.rateThresholdMin} required
          onChange={(e) => handleRoomTypeChange(room.id, "rateThresholdMin", e.target.value)}
        />
      </div>
      <div>
        <label>Max Rate Threshold <span style={{color:"red"}}>*</span></label>
        <input
          type="number" min="0" placeholder="Enter Maximum rate you can do"
          value={room.rateThresholdMax} required
          onChange={(e) => handleRoomTypeChange(room.id, "rateThresholdMax", e.target.value)}
        />
      </div>

      {/* Extra Mattress */}
      <div>
        <label>Count of Extra mattress</label>
        <input
          type="number" min="0" placeholder="Enter count of extra mattress"
          value={room.extraMattressCount}
          onChange={(e) => handleRoomTypeChange(room.id, "extraMattressCount", e.target.value)}
        />
      </div>
      <div>
        <label>Extra Adult Price</label>
        <input
          type="number" min="0" placeholder="Enter price per adult"
          value={room.extraMattressPriceAdult}
          onChange={(e) => handleRoomTypeChange(room.id, "extraMattressPriceAdult", e.target.value)}
        />
      </div>
      <div>
        <label>Extra Child Price</label>
        <input
          type="number" min="0" placeholder="Enter price per child"
          value={room.extraMattressPriceChild}
          onChange={(e) => handleRoomTypeChange(room.id, "extraMattressPriceChild", e.target.value)}
        />
      </div>

      {/* View / Window / Balcony (moved out of the Basic Amenities checkbox list) */}
      <div>
        <label>View from Room</label>
        <input
          type="text"
          placeholder="Enter the view from this room (e.g. Mountain, Pool, City)"
          value={room.viewFromRoom}
          onChange={(e) => handleRoomTypeChange(room.id, "viewFromRoom", e.target.value)}
        />
      </div>
      <div>
        <label>Window openable</label>
        <select
          value={room.windowOpenable}
          onChange={(e) => handleRoomTypeChange(room.id, "windowOpenable", e.target.value)}
        >
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
      <div>
        <label>Private balcony</label>
        <select
          value={room.privateBalcony}
          onChange={(e) => handleRoomTypeChange(room.id, "privateBalcony", e.target.value)}
        >
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
      <div>
        <label>Number of washroom</label>
        <input
          type="number"
          min="0"
          placeholder="Enter number of washrooms"
          value={room.numberOfWashrooms}
          onChange={(e) => handleRoomTypeChange(room.id, "numberOfWashrooms", e.target.value)}
        />
      </div>

      {/* Breakfast Type */}
      <div>
        <label>Breakfast Type</label>
        <input
          type="text"
          placeholder="Enter breakfast type (e.g. Continental, Buffet, A la carte)"
          value={room.breakfastType}
          onChange={(e) => handleRoomTypeChange(room.id, "breakfastType", e.target.value)}
        />
      </div>

      {/* Photos */}
      <div className="amenities-section" style={{ gridColumn: "1 / -1" }}>
        <div className="amenity-group">
          <h3>Room Photographs <span style={{ color: "red" }}>*</span></h3>
          <small style={{ color: "black", fontSize: "12px" }}>Max 4 photos allowed</small>
          <div className="document-upload-section" style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
            <div>
              <input required
                type="file"
                accept=".jpg,.jpeg,.png"
                multiple
                className="file-input"
                onChange={(e) => {
                  const files = Array.from(e.target.files || []);
                  const tooMany = files.length + (room.roomPhotographs?.length || 0) > 4;
                  const valid = files.filter(f => f.size <= 2 * 1024 * 1024);
                  if (files.length !== valid.length) alert("❌ Some files exceed 2MB and were skipped.");
                  if (tooMany) alert("❌ You can upload a maximum of 4 photos per room.");
                  handlePhotosAdd(room.id, valid.slice(0, Math.max(0, 4 - (room.roomPhotographs?.length || 0))));
                }}
              />
              <small style={{ color: "gray", fontSize: "12px" }}>
                Accepted formats: JPG, PNG (max size: 2MB each)
              </small>
            </div>

            {/* Previews */}
            <ul
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                maxWidth: "400px",
                margin: 0,
                padding: 0,
                listStyle: "none",
              }}
            >
              {(room.roomPhotographs || []).map((f, i) => {
                const url = typeof f === "string" ? null : URL.createObjectURL(f);
                return (
                  <li key={i} style={{ position: "relative" }}>
                    {url ? (
                      <img
                        src={url}
                        alt={`Room ${index + 1} - ${i + 1}`}
                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8, border: "1px solid #ccc" }}
                        onLoad={() => URL.revokeObjectURL(url)}
                      />
                    ) : (
                      <div
                        style={{
                          width: 100, height: 100, borderRadius: 8, border: "1px solid #ccc",
                          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12
                        }}
                      >
                        {f?.name || "Photo"}
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={() => handlePhotoRemove(room.id, i)}
                      style={{
                        position: "absolute", top: -8, right: -8, borderRadius: "50%", border: "none",
                        width: 24, height: 24, cursor: "pointer", background: "#f44", color: "#fff"
                      }}
                      title="Remove"
                    >
                      ×
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      {/* Amenities (per room) */}
      <div className="room-facilities" style={{ gridColumn: "1 / -1" }}>
        <h3>Room Level Amenities <span style={{color:'red'}}>*</span></h3>

        {/* Basic */}
        <h5>Basic Amenities</h5>
        <div className="amenity-options" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            ["Ac","Ac"], ["ceilingFan","Ceiling Fan"], ["wallFan","Wall Fan"], ["heater","Heater"],
            ["flatScreenTv","Flat screen TV"], ["foldupBed","Foldup bed"],
            ["sofaBed","Sofa bed"], ["sofa","Sofa"], ["radio","Radio"], ["videoGames","Video Games"],
            ["trashCans","Trash cans"], ["landline","Landline"], ["dressingRoomTable","Dressing room/table"],
            ["washingMachine","Washing Machine"], ["seatingArea","Seating area"], ["iron","Iron"], ["desk","Desk"],
            ["socketNearBed","Socket near bed"], ["featherPillow","Feather Pillow"], ["blankets","Blankets"],
            ["geyserHotWater","Geyser/hot water"], ["minifridge","Minifridge"], ["others","OTHERS"]
          ].map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={!!room.amenities?.[key]}
                onChange={(e) => handleAmenityToggle(room.id, key, e.target.checked)}
              /> {label}
            </label>
          ))}
        </div>
        {!!room.amenities?.Ac && (
          <div style={{ marginTop: 8, maxWidth: 250 }}>
            <label>AC Type</label>
            <select
              value={room.acType}
              onChange={(e) => handleRoomTypeChange(room.id, "acType", e.target.value)}
            >
              <option value="">Select</option>
              <option value="Centralized">Centralized</option>
              <option value="Room wise">Room wise</option>
            </select>
          </div>
        )}

        {/* Bathroom */}
        <h5 style={{ marginTop: 12 }}>Bathroom Amenities</h5>
        <div className="amenity-options" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            ["freeToiletries","Free Toiletries"], ["pvtBathroom","Pvt Bathroom"], ["sharedBathroom","Shared Bathroom"],
            ["toilet","Toilet"], ["toiletPaper","Toilet Paper"], ["bathTub","Bath tub"], ["bathRobe","Bathrobe"],
            ["shower","Shower"], ["towel","Towel"], ["hairdryer","Hairdryer"], ["slippers","Slippers"], ["spaBath","Spa Bath"],
            ["clothRack","Cloth rack"], ["dryingRack","Drying rack"], ["toothBrush","Tooth Brush"], ["toothPaste","Tooth Paste"],
            ["shampoo","Shampoo"], ["conditioner","Conditioner"], ["bodySoap","Body soap"], ["showerCap","Shower cap"]
          ].map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={!!room.amenities?.[key]}
                onChange={(e) => handleAmenityToggle(room.id, key, e.target.checked)}
              /> {label}
            </label>
          ))}
        </div>

        {/* Kitchenette */}
        <h5 style={{ marginTop: 12 }}>Kitchenette Amenities</h5>
        <div className="amenity-options" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            ["electricKettle","Electric Kettle"], ["diningArea","Dining area"], ["diningTable","Dining table"],
            ["toaster","Toaster"], ["waterBottle","Water Bottle"], ["gasStove","Gas Stove"], ["dishWasher","Dish Washer"],
            ["outdoorDiningArea","Outdoor Dining area"], ["kitchen","Kitchen"], ["minibar","Minibar"], ["microwave","Microwave"],
            ["refrigerator","Refrigerator"], ["teaCoffeeMaker","Tea / Coffee Maker"]
          ].map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={!!room.amenities?.[key]}
                onChange={(e) => handleAmenityToggle(room.id, key, e.target.checked)}
              /> {label}
            </label>
          ))}
        </div>

        {/* Food & Drink */}
        <h5 style={{ marginTop: 12 }}>Food & Drink</h5>
        <div className="amenity-options" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            ["wineGlasses","Wine glasses"], ["chocolateCookies","Chocolate/Cookies"],
            ["kidMeals","Kid Meals"], ["wineChampagne","Wine/Champagne"], ["barbeque","Barbeque"], ["buffet","Buffet"]
          ].map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={!!room.amenities?.[key]}
                onChange={(e) => handleAmenityToggle(room.id, key, e.target.checked)}
              /> {label}
            </label>
          ))}
        </div>

        {/* Services & Extra */}
        <h5 style={{ marginTop: 12 }}>Services & Extra Amenities</h5>
        <div className="amenity-options" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            ["fireAlarm","Fire Alarm"], ["fireExtinguisherInsideRoom","Fire Extinguisher Inside Rooms"],
            ["lockersInsideRooms","Lockers Inside Rooms"], ["alarmClock","Alarm clock"],
            ["wakeUpService","Wake up service"], ["executiveLoungeAccess","Executive lounge access"]
          ].map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={!!room.amenities?.[key]}
                onChange={(e) => handleAmenityToggle(room.id, key, e.target.checked)}
              /> {label}
            </label>
          ))}
        </div>
      </div>

      {/* Per-room comments */}
      <div style={{ gridColumn: "1 / -1" }}>
        <label>Comments (this room)</label>
        <textarea
          rows="2"
          value={room.comments}
          onChange={(e) => handleRoomTypeChange(room.id, "comments", e.target.value)}
          placeholder="Notes for this room type…"
        />
      </div>
    </div>
  </div>
))}

{/* Overall Room Types comment (top-level) */}
<div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
  <label>Have you mentioned all amenities correctly? <span style={{color:"red"}}>*</span></label>
  <textarea
    rows="3" required
    placeholder="Please crosscheck amenities and then type done..."
    name="roomTypeComments"
    value={formData.roomTypeComments || ""}
    onChange={handleChange}
  />
</div>

    </form>
  );
}
// RATE PLAN WITH RATES PAGE
else if (step === 7) {
  return (
    <form className="room-type-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p>Define all Rate Types/Tariff Plans you offer. As for Example, Room only(EP), With Breakfast(CP), Half Board(MAP), Full Board(AP)</p>
   {ratePlans.map((plan, index) => (
  <div className="rate-plan-card" key={plan.id}>
    <div className="room-type-header">
      <h4>Rate Plan {index + 1}</h4>
      <div className="room-type-actions">
        <button type="button" onClick={addRatePlan}>+</button>
        <button type="button" onClick={() => removeRatePlan(plan.id)}>-</button>
      </div>
    </div>

    <div className="form-grid">
      {/* Room Type Name (per card) */}
      <div>
        <label>Room Type Name <span style={{color:"red"}}>*</span></label>
        <input
          list="room-type-options"
          placeholder="Select or type room type"
          value={plan.roomTypeName}
          onChange={(e) => handleRatePlanChange(plan.id, "roomTypeName", e.target.value)}
          required
          style={{
            width: "92.5%", maxWidth: "100%", padding: "10px",
            borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px"
          }}
        />
        <datalist id="room-type-options">
          <option>Standard Room</option>
          <option>Standard Double Room</option>
          <option>Deluxe Room</option>
          <option>Deluxe Double Room</option>
          <option>Super Deluxe Room</option>
          <option>Family Room</option>
        </datalist>
      </div>

      {/* Rate Plan Name */}
      <div>
        <label>Room Plan Name <span style={{color:'blue'}}>*</span></label>
        <input
          type="text"
          placeholder="Enter plan name"
          value={plan.ratePlanName}
          onChange={(e) => handleRatePlanChange(plan.id, "ratePlanName", e.target.value)}
        />
      </div>

      {/* Base/Extra rates */}
      <div>
        <label>Base Rates <span style={{color:'red'}}>*</span></label>
        <input
          type="number" min="0" placeholder="₹ Enter prices"
          value={plan.baseRates}
          onChange={(e) => handleRatePlanChange(plan.id, "baseRates", e.target.value)}
          required
        />
      </div>

      <div>
        <label>Extra Adult Rates <span style={{color:'red'}}>*</span></label>
        <input
          type="number" min="0" placeholder="₹ Enter prices"
          value={plan.extraAdultRate}
          onChange={(e) => handleRatePlanChange(plan.id, "extraAdultRate", e.target.value)}
          required
        />
      </div>

      <div>
        <label>Extra Child Rates <span style={{color:'red'}}>*</span></label>
        <input
          type="number" min="0" placeholder="₹ Enter prices"
          value={plan.extraChildRate}
          onChange={(e) => handleRatePlanChange(plan.id, "extraChildRate", e.target.value)}
          required
        />
      </div>

      {/* Meal plan selection */}
      <div className="amenity-group" style={{ gridColumn: "1 / -1" }}>
        <h4>Select Rate plan <span style={{color:'red'}}>*</span></h4>

        <div className="amenity-options" style={{ display: "grid", gap: 12 }}>
          {/* EP */}
          <label>
            <input required
              type="checkbox"
              checked={plan.ep}
              onChange={(e) => handleRatePlanToggle(plan.id, "ep", e.target.checked)}
            /> EP
          </label>

          {/* CP */}
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={plan.hasCP}
              onChange={(e) => handleRatePlanToggle(plan.id, "hasCP", e.target.checked)}
            /> CP
            {plan.hasCP && (
              <input required
                type="number" min="0"
                placeholder="₹ Breakfast Price"
                value={plan.cpBreakfast}
                onChange={(e) => handleRatePlanChange(plan.id, "cpBreakfast", e.target.value)}
                style={{ display: "block", marginTop: 8, width: 200, padding: 5 }}
              />
            )}
          </label>

          {/* MAP */}
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={plan.hasMAP}
              onChange={(e) => handleRatePlanToggle(plan.id, "hasMAP", e.target.checked)}
            /> MAP
            {plan.hasMAP && (
              <div style={{ marginTop: 8 }}>
                <input required
                  type="number" min="0"
                  placeholder="₹ Breakfast Price"
                  value={plan.mapBreakfast}
                  onChange={(e) => handleRatePlanChange(plan.id, "mapBreakfast", e.target.value)}
                  style={{ display: "block", marginBottom: 6, width: 200, padding: 5 }}
                />
                <input required
                  type="number" min="0"
                  placeholder="₹ Lunch Price"
                  value={plan.mapLunch}
                  onChange={(e) => handleRatePlanChange(plan.id, "mapLunch", e.target.value)}
                  style={{ display: "block", width: 200, padding: 5 }}
                />
              </div>
            )}
          </label>

          {/* AP */}
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={plan.hasAP}
              onChange={(e) => handleRatePlanToggle(plan.id, "hasAP", e.target.checked)}
            /> AP
            {plan.hasAP && (
              <div style={{ marginTop: 8 }}>
                <input required
                  type="number" min="0"
                  placeholder="₹ Breakfast Price"
                  value={plan.apBreakfast}
                  onChange={(e) => handleRatePlanChange(plan.id, "apBreakfast", e.target.value)}
                  style={{ display: "block", marginBottom: 6, width: 200, padding: 5 }}
                />
                <input required
                  type="number" min="0"
                  placeholder="₹ Lunch Price"
                  value={plan.apLunch}
                  onChange={(e) => handleRatePlanChange(plan.id, "apLunch", e.target.value)}
                  style={{ display: "block", marginBottom: 6, width: 200, padding: 5 }}
                />
                <input required
                  type="number" min="0"
                  placeholder="₹ Dinner Price"
                  value={plan.apDinner}
                  onChange={(e) => handleRatePlanChange(plan.id, "apDinner", e.target.value)}
                  style={{ display: "block", width: 200, padding: 5 }}
                />
              </div>
            )}
          </label>
        </div>
      </div>
    </div>
  </div>
))}

{/* Single overall comment AFTER all rate plan cards */}
<div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
  <label>Rate Plan Comments...</label>
  <textarea
    rows="3"
    placeholder="Enter additional details here..."
    value={formData.ratePlanComments || ""}
    onChange={(e) => setFormData({ ...formData, ratePlanComments: e.target.value })}
  />
</div>

       {/* <div className="step-buttons"> <button type="submit">Submit</button></div> */}
    </form>
  );
}
// POLICY DETAILS PAGE
else if (step === 8) {
  return (
    <form
  className="room-type-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}
>
  <div className="amenity-group">
    <h3>P1. Do you allow unmarried couples?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="unmarriedCouples"
          value="Yes"
          checked={formData.unmarriedCouples === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input 
          type="radio"
          name="unmarriedCouples"
          value="No"
          checked={formData.unmarriedCouples === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P2. Do you allow guests below 18 years of age at your property?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="guestBelow18"
          value="Yes"
          checked={formData.guestBelow18 === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="guestBelow18"
          value="No"
          checked={formData.guestBelow18 === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P3. Groups with only male guests are allowed at your property?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="groupOnlyMale"
          value="Yes"
          checked={formData.groupOnlyMale === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="groupOnlyMale"
          value="No"
          checked={formData.groupOnlyMale === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P4. Are private parties or events allowed at the property?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="privateParties"
          value="Yes"
          checked={formData.privateParties === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="privateParties"
          value="No"
          checked={formData.privateParties === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P5. Can guests invite any outside visitors in the room during their stay?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="guestInvite"
          value="Yes"
          checked={formData.guestInvite === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="guestInvite"
          value="No"
          checked={formData.guestInvite === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P6. Is your property accessible for guests who use a wheelchair?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="accessibleForWheelchair"
          value="Yes"
          checked={formData.accessibleForWheelchair === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="accessibleForWheelchair"
          value="No"
          checked={formData.accessibleForWheelchair === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P7. Are pets allowed?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="petsAllowed"
          value="Yes"
          checked={formData.petsAllowed === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="petsAllowed"
          value="No"
          checked={formData.petsAllowed === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>
    {formData.petsAllowed === "Yes" && (
      <div style={{ marginTop: "8px" }}>
        <label>Pet Charges (leave blank if free)</label>
        <input
          type="text"
          placeholder="Enter pet charges, e.g. ₹500/night"
          name="petsAllowedCharges"
          value={formData.petsAllowedCharges}
          onChange={handleChange}
        />
      </div>
    )}

    <h3>P8. Do you have a 24-hour check-in?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="twentyfourCheckin"
          value="Yes"
          checked={formData.twentyfourCheckin === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input required
          type="radio"
          name="twentyfourCheckin"
          value="No"
          checked={formData.twentyfourCheckin === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P9. Child Age Policy?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="childAgePolicy"
          value="Yes"
          checked={formData.childAgePolicy === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="childAgePolicy"
          value="No"
          checked={formData.childAgePolicy === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>
    {formData.childAgePolicy === "Yes" && (
      <div style={{ marginTop: "8px" }}>
        <label>Up to what age is a child? (in years)</label>
        <input
          type="text"
          placeholder="Enter number of years"
          name="childAgePolicyYears"
          value={formData.childAgePolicyYears}
          onChange={handleChange}
          required
        />
      </div>
    )}

    <h3>P10. Extra Bed Policy?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="extraBedPolicy"
          value="Yes"
          checked={formData.extraBedPolicy === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input required
          type="radio"
          name="extraBedPolicy"
          value="No"
          checked={formData.extraBedPolicy === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P11. Booking cancellation before check-in</h3>
    <div className="amenity-options">
      {["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"].map(
        (day) => (
          <label key={day}>
            <input required
              type="radio"
              name="bookingCancellationBefore"
              value={day}
              checked={formData.bookingCancellationBefore === day}
              onChange={handleChange}
            />{" "}
            {day}
          </label>
        )
      )}
    </div>

    <h3>P12. Non veg allowed?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="nonVegAllowed"
          value="Yes"
          checked={formData.nonVegAllowed === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="nonVegAllowed"
          value="No"
          checked={formData.nonVegAllowed === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P13. Outside food delivery allowed?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="outsideFoodDeliveryAllowed"
          value="Yes"
          checked={formData.outsideFoodDeliveryAllowed === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="outsideFoodDeliveryAllowed"
          value="No"
          checked={formData.outsideFoodDeliveryAllowed === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P14. Alcohol consumption allowed?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="alcoholAllowed"
          value="Yes"
          checked={formData.alcoholAllowed === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="alcoholAllowed"
          value="No"
          checked={formData.alcoholAllowed === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <h3>P15. First aid kit provided?</h3>
    <div className="amenity-options">
      <label>
        <input required
          type="radio"
          name="firstAidKitProvided"
          value="Yes"
          checked={formData.firstAidKitProvided === "Yes"}
          onChange={handleChange}
        />{" "}
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="firstAidKitProvided"
          value="No"
          checked={formData.firstAidKitProvided === "No"}
          onChange={handleChange}
        />{" "}
        No
      </label>
    </div>

    <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
      <label>Did we miss any Policy? Mention below ⮯</label>
      <textarea
        rows="3"
        className="textarea-input"
        onChange={handleChange}
        placeholder="Enter additional details here else type NA..." name="policyComments" value={formData.policyComments}
      />
    </div>
  </div>

  {/* <div className="step-buttons"><button type="submit">Submit</button></div> */}
</form>

  );
}
// PAYMENT METHODS PAGE
else if (step === 9) {
  return (
    <form
  className="room-type-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}
>
  <p>
    Define all Payment Types you may accept at your Property. As for example Cash, Credit Card, Check etc.
  </p>
  <div>
    <label>
      Payment Methods <span style={{ color: "red" }}>*</span>
    </label>
    
    <input
      type="text"
      placeholder="Enter payment methods"
      name="paymentMethods"
      value={formData.paymentMethods || ""}
      onChange={handleChange}
      required
    />
    <small style={{ color: "gray", fontSize: "12px" }}>
    Separate multiple payment methods with commas like cheque, credit card, etc.
  </small>
  </div> 

  <label htmlFor="paymentmethod" className="upload-label">
    Bank Details Documents
  </label>
  <div>
    <label>
      Account No. <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="number"
      placeholder="Enter account number"
      name="accountNumber"
      value={formData.accountNumber || ""}
      onChange={handleChange}
      required
    />
  </div>

  <div>
    <label>
      Account Holder Name <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      placeholder="Enter account holder name"
      name="accountHolderName"
      value={formData.accountHolderName || ""}
      onChange={handleChange}
      required
    />
  </div>

  <div>
    <label>
      IFSC Code <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      placeholder="Enter IFSC code"
      name="ifsc"
      value={formData.ifsc || ""}
      onChange={handleChange}
      required
    />
  </div>

  <div>
    <label>
      Branch Name <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      placeholder="Enter branch name"
      name="branchName"
      value={formData.branchName || ""}
      onChange={handleChange}
      required
    />
  </div>

  {/* Cancelled Cheque Upload */}
<div className="document-upload-section">
  <label htmlFor="cancelledCheque" className="upload-label">
    Cancelled Cheque <span style={{ color: "red" }}>*</span>
  </label>
  <input
  type="file"
  required
  id="cancelledCheque"
  name="cancelledCheque"
  accept=".pdf,.jpg,.jpeg,.png"
  className="file-input"
  onChange={(e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      alert("❌ File size exceeds 2MB limit.");
      e.target.value = "";
      return;
    }

    // ✅ store the actual File object (NOT just the name)
    setFormData((prev) => ({
      ...prev,
      cancelledCheque: file,
    }));
  }}
/>

  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF, JPG, PNG (max size: 2MB)
  </small>
</div>


{/* ✅ Payment QR Upload */}
<div className="document-upload-section">
  <label htmlFor="paymentQr" className="upload-label">
    Payment QR <span style={{ color: "blue" }}>*</span>
  </label>
 <input
  type="file"
  id="paymentQr"
  name="paymentQr"
  accept=".pdf,.jpg,.jpeg,.png"
  className="file-input"
  onChange={(e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      alert("❌ File size exceeds 2MB limit.");
      e.target.value = "";
      return;
    }

    // ✅ store the actual File object
    setFormData((prev) => ({
      ...prev,
      paymentQr: file,
    }));
  }}
/>

  <small style={{ color: "gray", fontSize: "12px" }}>
    Accepted formats: PDF, JPG, PNG (max size: 2MB)
  </small>
</div>



  <div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
    <label>If you want to provide additional information...</label>
    <textarea
      rows="3"
      placeholder="Enter additional details here..." name="paymentMethodComments" value={formData.paymentMethodComments} onChange={handleChange}
    />
  </div>

  {/* <div className="step-buttons"><button type="submit">Submit</button></div> */}
</form>

  );
}
// OTA INFORMATION PAGE
else if (step === 10) {
  return (
    <form className="room-type-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p>OTA Login Credentials</p>
    {otaInfo.map((ota, index) => (
  <div className="ota-info-card" key={ota.id}>
    <div className="room-type-header">
      <h4>OTA Info {index + 1}</h4>
      <div className="room-type-actions">
        <button type="button" onClick={addOtaInfo}>+</button>
        <button type="button" onClick={() => removeOtaInfo(ota.id)}>-</button>
      </div>
    </div>

    <div className="form-grid">
      {/* OTA / Channel Name */}
      <div>
        <label>
          OTA / Channel Name <span style={{ color: "red" }}>*</span>
        </label>
        <input
          list="ota-options"
          placeholder="Enter OTA"
          value={ota.otaName}
          onChange={(e) =>
            handleOtaInfoChange(ota.id, "otaName", e.target.value)
          }
          required
          style={{
            width: "92.5%",
            maxWidth: "100%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <datalist id="ota-options">
          <option>MMT</option>
          <option>Agoda</option>
          <option>Booking</option>
          <option>Cleartrip</option>
          <option>Easemytrip</option>
          <option>Expedia</option>
          <option>Goibibo</option>
          <option>Not Listed</option>
        </datalist>
      </div>

      {/* Property Code */}
      <div>
        <label>
          Property Code <span style={{ color: "blue" }}>*</span>
        </label>
        <input
          type="text"
          placeholder="Enter code"
          value={ota.propertyCode}
          onChange={(e) =>
            handleOtaInfoChange(ota.id, "propertyCode", e.target.value)
          }
        />
      </div>

     {/* Username */}
<div>
  <label>OTA Username <span style={{ color: "blue" }}>*</span></label>
  <input
    type="text"
    placeholder="Enter OTA username"
    value={ota.otaUserName}
    onChange={(e) => handleOtaInfoChange(ota.id, "otaUserName", e.target.value)}
    id={`otaUserName_${ota.id}`}
    name={`otaUserName_${ota.id}`}   // unique, avoids collisions
    autoComplete="off"
    autoCapitalize="off"
    spellCheck={false}
  />
</div>

{/* Password (masked, no reveal) */}
<div>
  <label>OTA Password <span style={{ color: "blue" }}>*</span></label>
  <input
    type="text"
    placeholder="OTA Password"
    value={ota.otaPassword}
    onChange={(e) => handleOtaInfoChange(ota.id, "otaPassword", e.target.value)}
    id={`otaPassword_${ota.id}`}
    name={`otaPassword_${ota.id}`}   // unique
    autoComplete="new-password"      // prevents stored creds reuse
    autoCapitalize="off"
    spellCheck={false}
  />
</div>


    </div>
  </div>
))}

{/* Single overall comment AFTER all items */}
<div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
  <label>If you want to provide additional information...</label>
  <textarea
    rows="3"
    placeholder="Enter additional details here..."
    name="otaInfoComments"
    value={formData.otaInfoComments || ""}
    onChange={(e) =>
      setFormData({ ...formData, otaInfoComments: e.target.value })
    }
  />
</div>

      {/* <div className="step-buttons"> <button type="submit">Submit</button></div> */}
    </form>
  );
}
// SOCIAL MEDIA DETAILS PAGE
else if (step === 11) {
    return (
     <form
  className="contact-person-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}
>
  <div className="form-grid">
    <h4
      style={{
        background: "linear-gradient(45deg, #F58529, #DD2A7B)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "600",
      }}
    >
      Instagram Details
    </h4>
    <br />
    <div>
      <label>
        Insta Exists <span style={{ color: "red" }}>*</span>
      </label>
      <select
        required
        name="instaExists"
        value={formData.instaExists}
        onChange={handleChange}
      >
        <option value="">Select here</option>
        <option>Yes</option>
        <option>Yes, but no access</option>
        <option>Need to create</option>
      </select>
    </div>
    <div>
      <label>Instagram Username</label>
      <input
        type="text"
        name="instaUsername"
        value={formData.instaUsername}
        onChange={handleChange}
        placeholder="Enter username"
      />
    </div>
    <div>
      <label>Password</label>
      <input
        type="text"
        name="instaPassword"
        value={formData.instaPassword}
        onChange={handleChange}
        placeholder="Instagram password"
      />
    </div>
    <br />
    <h4
      style={{
        background: "linear-gradient(45deg, #0061feff, #009cccff)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "600",
      }}
    >
      Facebook Details
    </h4>
    <br />
    <div>
      <label>
        Page Exists <span style={{ color: "red" }}>*</span>
      </label>
      <select
        required
        name="facebookExists"
        value={formData.facebookExists}
        onChange={handleChange}
      >
        <option value="">Select here</option>
        <option>Yes</option>
        <option>Yes, but no access</option>
        <option>Need to create</option>
      </select>
    </div>
    <div>
      <label>Facebook Page Name</label>
      <input
        type="text"
        name="facebookUsername"
        value={formData.facebookUsername}
        onChange={handleChange}
        placeholder="Enter page name"
      />
    </div>
    <div>
      <label>Password</label>
      <input
        type="text"
        name="facebookPassword"
        value={formData.facebookPassword}
        onChange={handleChange}
        placeholder="Facebook password"
      />
    </div>
    <br />
    <h4
      style={{
        background:
          "linear-gradient(45deg, #fe0000ff, #ccbb00ff,#03cc00ff,#0014ccff)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "600",
      }}
    >
      Google Business Details
    </h4>
    <br />
    <div>
      <label>
        Profile Exists <span style={{ color: "red" }}>*</span>
      </label>
      <select
        required
        name="googleProfileExists"
        value={formData.googleProfileExists}
        onChange={handleChange}
      >
        <option value="">Select here</option>
        <option>Yes</option>
        <option>Yes, but no access</option>
        <option>Need to create</option>
      </select>
    </div>
    <div>
      <label>Google Profile</label>
      <input
        type="text"
        name="googleProfile"
        value={formData.googleProfile}
        onChange={handleChange}
        placeholder="Business name listed on Google"
      />
    </div>
    <div>
      <label>Primary ID</label>
      <input
        type="text"
        name="primaryID"
        value={formData.primaryID}
        onChange={handleChange}
        placeholder="Mention primary id that manages it"
      />
    </div>
    <div>
      <label>Mobile Number present on page? <span style={{color:"red"}}>*</span></label>
      <select
        name="mobileNumberPresent"
        value={formData.mobileNumberPresent}
        onChange={handleChange}
      >
        <option value="" disabled>Select here</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>
    <div>
      <label>Mobile Number for updation</label>
      <input
        type="text"
        name="mobileNumberForUpdation"
        value={formData.mobileNumberForUpdation}
        onChange={handleChange}
        placeholder="Enter number else na if updated"
        maxLength="10"
      />
    </div>
    <br />
    <h4
      style={{
        background: "linear-gradient(45deg, #00fe00ff, #009cccff)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "600",
      }}
    >
      Tripadvisor Details
    </h4>
    <br />
    <div>
      <label>
        Listing Exists <span style={{ color: "red" }}>*</span>
      </label>
      <select
        required
        name="listingExists"
        value={formData.listingExists}
        onChange={handleChange}
      >
        <option value="">Select here</option>
        <option>Yes</option>
        <option>Yes, but no access</option>
        <option>Need to create</option>
      </select>
    </div>
    <div>
      <label>Phone Number</label>
      <input
        type="text"
        name="phoneNumberTripadvisor"
        value={formData.phoneNumberTripadvisor}
        onChange={handleChange}
        placeholder="Enter phone number"
        maxLength="10"
      />
    </div>
    <h4>Website Details</h4>
    <br />
    <div>
      <label>
        Website Exists <span style={{ color: "red" }}>*</span>
      </label>
      <select
        required
        name="websiteExists"
        value={formData.websiteExists}
        onChange={handleChange}
      >
        <option value="">Select here</option>
        <option>Yes</option>
        <option>Yes, but no access</option>
        <option>Need to create</option>
      </select>
    </div>
    <div>
      <label>Website Domain</label>
      <input
        type="text"
        name="websiteDomain"
        value={formData.websiteDomain}
        onChange={handleChange}
        placeholder="Like: Hostinger, GoDaddy etc"
      />
    </div>
    <div>
      <label>Website Link</label>
      <input
        type="text"
        name="websiteLink"
        value={formData.websiteLink}
        onChange={handleChange}
        placeholder="Paste link here"
      />
    </div>
    <div>
      <label>Website ID</label>
      <input
        type="text"
        name="websiteID"
        value={formData.websiteID}
        onChange={handleChange}
        placeholder="Enter Id"
      />
    </div>
    <div>
      <label>Website Password</label>
      <input
        type="text"
        name="websitePassword"
        value={formData.websitePassword}
        onChange={handleChange}
        placeholder="Enter password"
      />
    </div>
    <div>
      <label>Webmail ID</label>
      <input
        type="text"
        name="webmailID"
        value={formData.webmailID}
        onChange={handleChange}
        placeholder="Enter Id"
      />
    </div>
    <div>
      <label>Webmail Password</label>
      <input
        type="text"
        name="webmailPassword"
        value={formData.webmailPassword}
        onChange={handleChange}
        placeholder="Enter password"
      />
    </div>
    <div>
      <label>Hotel Id</label>
      <input
        type="text"
        name="hotelID"
        value={formData.hotelID}
        onChange={handleChange}
        placeholder="Enter Id"
      />
    </div>
    <div>
      <label>Hotel Id Password</label>
      <input
        type="text"
        name="hotelIDPassword"
        value={formData.hotelIDPassword}
        onChange={handleChange}
        placeholder="Enter password"
      />
    </div>
    <div style={{ gridColumn: "1 / -1" }}>
      <label>If you want to provide additional information...</label>
      <textarea
        rows="3"
        placeholder="Enter additional details here..." name="credentialComments" value={formData.credentialComments} onChange={handleChange}
      />
    </div>
  </div>
  {/* <div className="step-buttons"><button type="submit">Submit</button></div> */}
</form>

    );
  } 
// EXTRA CHARGES PAGE
else if (step === 12) {
  return (
    <form
  className="room-type-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}
>
  <p>
    Define all Extra Charges Guest may entitle for, like Phone Calls, Laundry,
    Extra Mattress.
  </p>

  {extraCharges.map((charge, index) => (
  <div className="extra-charge-card" key={charge.id}>
    <div className="room-type-header">
      <h4>Extra Charge {index + 1}</h4>
      <div className="room-type-actions">
        <button type="button" onClick={addExtraCharge}>+</button>
        <button type="button" onClick={() => removeExtraCharge(charge.id)}>-</button>
      </div>
    </div>

    <div className="form-grid">
      {/* ✅ Charge Name */}
      <div>
        <label>
          Charge Name <span style={{ color: "red" }}>*</span>
        </label>
        <input required
          list="charge-options"
          placeholder="Select or type charge name"
          value={charge.extraChargeName}
          onChange={(e) =>
            handleExtraChargeChange(charge.id, "extraChargeName", e.target.value)
          }
          style={{
            width: "92.5%",
            maxWidth: "100%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <datalist id="charge-options">
          <option value="No Extra Charges" />
          <option value="Car Wash" />
          <option value="Extra Bed/Mattress" />
          <option value="Heater Service" />
          <option value="Liquor Service" />
          <option value="Shuttle Service" />
          <option value="Spa Service" />
          <option value="Tour Guide" />
        </datalist>
      </div>

      {/* ✅ Price */}
      <div>
        <label>
          Price <span style={{ color: "blue" }}>*</span>
        </label>
        <input
          type="text"
          placeholder="₹ Enter price"
          value={charge.extraChargePrice}
          onChange={(e) =>
            handleExtraChargeChange(charge.id, "extraChargePrice", e.target.value)
          }
        />
      </div>

      {/* ✅ % Charged */}
      <div>
        <label>% Charged <span style={{ color: "blue" }}>*</span></label>
        <select
          value={charge.extraPercentageCharged}
          onChange={(e) =>
            handleExtraChargeChange(
              charge.id,
              "extraPercentageCharged",
              e.target.value
            )
          }
        >
          <option value="">N/A</option>
          <option value="5% GST">5% GST</option>
          <option value="12% GST">12% GST</option>
          <option value="18% GST">18% GST</option>
        </select>
      </div>
    </div>
  </div>
))}


  {/* ✅ Additional Info */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
    <label>If you want to provide additional information...</label>
    <textarea
      rows="3"
      placeholder="Enter additional details here..." name="extraChargesComments" value={formData.extraChargesComments} onChange={handleChange}
    />
  </div>
</form>

  );
}

// FAQ PAGE
else if (step === 13) {
  return (
    <form
  className="room-type-form"
  onSubmit={handleSubmit}
  style={{ display: "flex", flexDirection: "column", gap: "10px" }}
>
  {/* Q1 */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
    <label>Q1. How many room categories are there?</label>
    <textarea
      rows="3"
      name="howManyRoomCategories"
      value={formData.howManyRoomCategories}
      onChange={handleChange}
      placeholder="Enter categories here..."
      className="textarea-input"
    />
  </div>

  {/* Q2 */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
    <label>Q2. Total Room Inventory available at the property?</label>
    <textarea
      rows="3"
      name="totalRoomInventories"
      value={formData.totalRoomInventories}
      onChange={handleChange}
      placeholder="Enter room inventory..."
      className="textarea-input"
    />
  </div>

  {/* Q3 */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
    <label>Q3. Unique Selling Factor?</label>
    <textarea
      rows="3"
      name="uniqueSellingPoint"
      value={formData.uniqueSellingPoint}
      onChange={handleChange}
      placeholder="Provide usp..."
      className="textarea-input"
    />
  </div>

  {/* Q4 */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
    <label>Q4. Nearby Popular locations with their exact distance from property?</label>
    <textarea
      rows="3"
      name="nearbyPopularLocations"
      value={formData.nearbyPopularLocations}
      onChange={handleChange}
      placeholder="Enter nearby locations..."
      className="textarea-input"
    />
  </div>

  {/* Q5 */}
  <div style={{ gridColumn: "1 / -1", marginTop: "1.5rem" }}>
    <label>Q5. Paste link for Current Location of Property <span style={{ color: "red" }}>*</span></label>
    <input type="url" required
      name="liveLocation"
      value={formData.liveLocation}
      onChange={handleChange}
      placeholder="Paste link here..."
      className="textarea-input"
    />
  </div>

  <br/>
  <div style={{ gridColumn: "1 / -1" }}>
            <label>If you want to provide additional information...</label>
            <textarea rows="3" placeholder="Enter additional details here..." name="faqComments" value={formData.faqComments} onChange={handleChange}/>
          </div>
  <div className="submit-buttons">
    <button type="submit" disabled={!canSubmitFillDgf} title={!canSubmitFillDgf ? "You don't have permission to submit this form." : undefined}>
      Submit
    </button>
  </div>
</form>

  );
}
// OVERVIEW PAGE
    else {
  return (
  <div className="placeholder-step">
  <h3 style={{ color: "#2e7d32", marginBottom: "15px" }}>
    📋 Overview of Submitted Property Details
  </h3>
  {!submittedData ? (
    <p style={{ color: "gray" }}>No data submitted yet.</p>
  ) : (
    <div
      style={{
        background: "#f9f9f9",
        padding: "20px",
        borderRadius: "10px",
        border: "1px solid #ddd",
      }}
    >
      {[{
        title:"READ GUIDELINES",
        keys: ["guidelinesComment"]
      },
        {
          title: "🏠 PROPERTY DETAILS",
          keys: [
            "propertyName","propertyType","PropertyAddress","country","state","city","pinCode","bill","gst",
            "receptionNumber","marketingNumber","propertyEmail","propertyWebsite","invoiceNumber","ratesAre",
            "starCategory","importFuture","checkIn","checkOut","buildingFloors","buildingRooms","propertyComments"
          ]
        },
        {
          title: "📞 CONTACT DETAILS",
          keys: [
            "ownerContactName","ownerDesignation","ownerDOB","ownerStateCity","ownerEmail","ownerMobileNumber",
            "managerContactName","managerDesignation","managerEmail","managerMobileNumber",
            "billingContactName","billingDesignation","billingEmail","billingMobileNumber"
          ]
        },
        {
          title: "📄 DOCUMENTS",
          keys: [
            "gstCertificate","hasLeaseAgreement",
"leaseAgreement","msmeDocument","utilityBill","aadhaarCard",
            "panCard","otherDocument","letterHead","documentComments"
          ]
        },
        {
          title: "📆 SEASONAL TRENDS",
          keys: ["peakSeasons","midSeasons","lowSeasons","seasonalTrendsComments"]
        },
        {
          title: "Most Popular Facilities",
          keys: ["Restaurant","Terrace","Lift","WiFi","TwentyFourService","AirConditioner","Garden","RoomService","Bar","Sauna","SaunaCharges","AirportShuttle","AirportShuttleCharges","Jacuzzi","JacuzziCharges",
            "WaterPark","WaterParkCharges","Spa","SpaCharges","Parking","ParkingCharges","FacilityforDisabled","FacilityforDisabledCharges","GameRoom","GameRoomCharges","PrivateTaxi","PrivateTaxiCharges"]
        },
        {
          title: "Pool Amenities",
          keys: ["PoolCover","PoolTowels","PrivatePool","PrivatePoolCharges","HeatedPool","HeatedPoolCharges","InfinityPool","InfinityPoolCharges","PlungePool","PlungePoolCharges","PoolWithView","PoolWithViewCharges",
            "RoofTopPool","RoofTopPoolCharges","SaltWaterPool","SaltWaterPoolCharges","KidsPool","KidsPoolCharges","OpenAllYear","AllAgesWelcome","IndoorPoolWithView"]
        },
        {
          title: "Reception Services",
          keys: ["InvoiceProvided","TourDesk","Lockers","LockersCharges","LuggageStorage","LuggageStorageCharges"]
        },
        {
          title: "Outdoor Features",
          keys: ["OutdoorFurniture","SunTerrace"]
        },
        {
          title: "Activities",
          keys: [ "BicycleRental","BicycleRentalCharges", "WalkingTours","WalkingToursCharges","Darts","DartsCharges","IndoorPlayArea","IndoorPlayAreaCharges","BoardGamesPuzzles","BoardGamesPuzzlesCharges","EveningEntertainment","EveningEntertainmentCharges",
            "LiveMusicPerformance","LiveMusicPerformanceCharges","TableTennis","TableTennisCharges","Billiards","BilliardsCharges","Bonfire","BonfireCharges"]
        },
        {
          title: "Food & Drinks",
          keys: ["SnackBar","SnackBarCharges","Wine","WineCharges","Fruits","FruitsCharges", "Snacks","SnacksCharges"]
        },
        {
          title: "Cleaning Services",
          keys: ["DailyHousekeeping","IroningServices","IroningServicesCharges","Laundry","LaundryCharges"]
        },
        {
          title: "Wellness",
          keys:["YogaClasses","YogaClassesCharges","Fitness","FitnessCharges","SpaFacilities","SpaFacilitiesCharges"]
        },
        {
          title: "Busines Facilities",
          keys: [ "FaxPhotocopying","FaxPhotocopyingCharges","BusinessCenter","BusinessCenterCharges","MeetingBanquetRooms", "MeetingBanquetRoomsCharges"]
        },
        {
          title: "Safety & Security",
          keys: ["FireExtinguisher","CctvOutsideProperty","CctvinCommonAreas","SmokeAlarm", "SecurityAlarm","KeyCardAccess","TwentyFourSecurity","SafetyDepositBox"]
        },
        {
          title: "General",
          keys: [ "SharedLoungeTVArea","DesignatedSmokingArea", "TileMarbleFloor","Soundproofing","Fan","FamilyRooms","SmokingAllowed","SmokingNotAllowed"]
        },
        {
          title: "Accessibility",
          keys: [ "WheelchairAccessible", "UpperFloorsAccessiblebyElevator"]
        },
        {
          title: "Languages Spoken",
          keys: ["Hindi","English","LocalLanguage","facilitiesComments"]
        },
        {
  title: "🛏️ ROOM TYPE DETAILS",
  dataKey: "roomTypes",          // 👈 array key in payload
  commentKey: "roomTypeComments", // 👈 top-level textarea (overall comment)
  itemLabel: "Room Type",         // 👈 used for card headings
  emptyText: "No room types added.",
  keys: [
    "name",
    "bedType",
    "roomSize",
    "roomNumbers",
    "bedsCountPerRoom",
    "baseAdult",
    "maxAdult",
    "baseChild",
    "maxChild",
    "maxOccupancy",
    "roomInventory",
    "rateThresholdMin",
    "rateThresholdMax",
    "extraMattressCount",
    "extraMattressPriceAdult",
    "extraMattressPriceChild",
    "viewFromRoom",
    "windowOpenable",
    "privateBalcony",
    "numberOfWashrooms",
    "breakfastType",
    "acType",
    "roomPhotographs",
    "amenities",
    "comments" // per-room note
  ],
}
,
        {
  title: "💰 RATE PLAN",
  dataKey: "ratePlans",
  commentKey: "ratePlanComments",   // single overall comment
  itemLabel: "Rate Plan",
  emptyText: "No rate plans added.",
  keys: [
    "roomTypeName",
    "ratePlanName",
    "baseRates",
    "extraAdultRate",
    "extraChildRate",
    "ep",
    "hasCP","cpBreakfast",
    "hasMAP","mapBreakfast","mapLunch",
    "hasAP","apBreakfast","apLunch","apDinner",
  ],
}
,
        {
          title: "📜 POLICY DETAILS",
          keys: [
            "unmarriedCouples","guestBelow18","groupOnlyMale","privateParties","guestInvite", "accessibleForWheelchair","petsAllowed","petsAllowedCharges","twentyfourCheckin","childAgePolicy","childAgePolicyYears","extraBedPolicy", "nonVegAllowed","outsideFoodDeliveryAllowed","alcoholAllowed","firstAidKitProvided", "bookingCancellationBefore","policyComments"
          ]
        },
        {
  title: "🏦 PAYMENT METHODS",
  keys: [
    "paymentMethods", "accountNumber", "accountHolderName", "ifsc", "branchName", "cancelledCheque", "paymentQr", "paymentMethodComments"
  ]
}
,
       // 🌐 OTA INFORMATION as dynamic cards + one overall comment
  {
    title: "🌐 OTA INFORMATION",
    dataKey: "otaInfo",
    commentKey: "otaInfoComments",
    itemLabel: "OTA Info",
    emptyText: "No OTA information added.",
    keys: ["otaName","propertyCode","otaUserName","otaPassword"]
  },
        {
          title: "🔐 CREDENTIALS",
          keys: [
            "instaExists","instaUsername","instaPassword",
            "facebookExists","facebookUsername","facebookPassword",
            "googleProfileExists","googleProfile","primaryID","mobileNumberPresent",
            "mobileNumberForUpdation","listingExists","phoneNumberTripadvisor","websiteExists",
            "websiteDomain","websiteLink","websiteID","websitePassword","webmailID","webmailPassword","hotelID","hotelIDPassword","credentialComments"
          ]
        },
       {
  title: "💸 EXTRA CHARGES",
  dataKey: "extraCharges",
  commentKey: "extraChargesComments", 
  keys: [
    "extraChargeName",
    "extraChargePrice",
    "extraPercentageCharged",
  ],
}
,
        {
          title: "❓ FAQ SECTION",
          keys: [
            "howManyRoomCategories","totalRoomInventories","uniqueSellingPoint","nearbyPopularLocations", "liveLocation","faqComments"
          ]
        }
      ].map((section, index) => {
  const pretty = (k) =>
    k.replace(/([A-Z])/g, " $1").replace(/^\w/, (c) => c.toUpperCase());

  // ===== Array-based sections (OTA / Extra Charges) =====
  if (section.dataKey) {
    const rows = submittedData?.[section.dataKey];
    const hasRows = Array.isArray(rows) && rows.length > 0;

    const overallCommentKey = section.commentKey;
    const overallComment = overallCommentKey ? submittedData?.[overallCommentKey] : undefined;

    return (
      <div key={index} style={{ marginBottom: "30px" }}>
        <h4
          style={{
            color: "#41a901ff",
            borderBottom: "2px solid #41a901ff",
            paddingBottom: "5px",
            marginBottom: "15px",
          }}
        >
          {section.title}
        </h4>

        {!hasRows ? (
          <p style={{ color: "gray" }}>{section.emptyText || "No items added."}</p>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "12px",
              }}
            >
              {rows.map((row, i) => (
                <div
                  key={row?.id ?? i}
                  style={{
                    background: "#fff",
                    borderRadius: "8px",
                    padding: "10px 12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    whiteSpace: "pre-line",
                  }}
                >
                  <strong style={{ color: "#01a30aff", display: "block", marginBottom: 8 }}>
                    {(section.itemLabel || "Item") + " " + (i + 1)}
                  </strong>

               {section.keys.map((k) => {
  const v = row?.[k];

  const mealFlags = ["ep", "hasCP", "hasMAP", "hasAP"];

  // ✅ SPECIAL CASE: AMENITIES AS NUMBERED COLUMN LIST
  if (k === "amenities" && v && typeof v === "object") {
    const selectedAmenities = Object.entries(v)
      .filter(([, checked]) => checked)
      .map(([key]) =>
        key
          .replace(/([A-Z])/g, " $1")
          .replace(/^\w/, (c) => c.toUpperCase())
      );

    return (
      <div key={k} style={{ marginBottom: 8 }}>
        <div style={{ color: "#333", textTransform: "capitalize" }}>
          {pretty(k)}
        </div>

        {selectedAmenities.length ? (
          <ol className="roomamenities-list">
            {selectedAmenities.map((label, index) => (
              <li key={index}>{label}</li>
            ))}
          </ol>
        ) : (
          <p
            style={{
              margin: "5px 0 0 0",
              color: "#555",
              fontSize: "14px",
              wordBreak: "break-word",
              textAlign: "justify",
            }}
          >
            None selected
          </p>
        )}
      </div>
    );
  }

  // ✅ GENERIC HANDLING FOR ALL OTHER FIELDS
  let rendered;
  if (Array.isArray(v)) {
    rendered = v.join("\n");
  } else if (typeof v === "boolean" && mealFlags.includes(k)) {
    rendered = v ? "Included" : "Not Included";
  } else if (typeof v === "boolean") {
    rendered = v ? "Yes" : "No";
  } else if (typeof v === "string") {
    rendered = v.replace(/,/g, "\n");
  } else {
    rendered = v ?? "—";
  }

  const isMealFlag = mealFlags.includes(k) && typeof v === "boolean";
  const color = isMealFlag ? (v ? "green" : "red") : "#555";

  return (
    <div key={k} style={{ marginBottom: 8 }}>
      <div style={{ color: "#333", textTransform: "capitalize" }}>
        {pretty(k)}
      </div>
      <p
        style={{
          margin: "5px 0 0 0",
          color,
          fontSize: "14px",
          wordBreak: "break-word",
          textAlign: "justify",
          whiteSpace: "pre-line",
        }}
      >
        {rendered}
      </p>
    </div>
  );
})}




                  
                </div>
              ))}
            </div>

            {/* === Single Overall Comment after all items === */}
            {overallCommentKey && (overallComment ?? "") !== "" && (
              <div
                style={{
                  marginTop: 16,
                  background: "#fff",
                  borderRadius: "8px",
                  padding: "12px 14px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  whiteSpace: "pre-line",
                }}
              >
                <strong style={{ color: "#333" }}>
                  {pretty(overallCommentKey)}
                </strong>
                <p
                  style={{
                    margin: "6px 0 0 0",
                    color: "#555",
                    fontSize: "14px",
                    wordBreak: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {typeof overallComment === "string"
                    ? overallComment
                    : Array.isArray(overallComment)
                    ? overallComment.join("\n")
                    : overallComment ?? "—"}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  // ===== Simple key/value sections (existing path) =====
  const sectionData = Object.entries(submittedData).filter(([key]) =>
    section.keys.includes(key)
  );
  if (sectionData.length === 0) return null;

  return (
    <div key={index} style={{ marginBottom: "30px" }}>
      <h4
        style={{
          color: "#41a901ff",
          borderBottom: "2px solid #41a901ff",
          paddingBottom: "5px",
          marginBottom: "15px",
        }}
      >
        {section.title}
      </h4>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "12px",
        }}
      >
        {sectionData.map(([key, value]) => {
          // special case: amenities yes/no + Charges
let rendered;
if (typeof value === "string" && (value === "yes" || value === "no")) {
  const chargeKey = `${key}Charges`;
  const chargeValue = submittedData?.[chargeKey];
  rendered =
    value === "yes"
      ? chargeValue
        ? `✅ Available — ₹${chargeValue}`
        : "✅ Available"
      : "❌ Not Available";
} else if (Array.isArray(value)) {
  rendered = value.join("\n");
} else if (typeof value === "object" && value !== null) {
  rendered = JSON.stringify(value, null, 2);
} else if (typeof value === "string") {
  rendered = value.replace(/,/g, "\n");
} else {
  rendered = value ?? "—";
}
          return (
            <div
              key={key}
              style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "10px 12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                whiteSpace: "pre-line",
              }}
            >
              <strong style={{ color: "#333", textTransform: "capitalize" }}>
                {pretty(key)}
              </strong>
              <p
                style={{
                  margin: "5px 0 0 0",
                  color: "#555",
                  fontSize: "14px",
                  wordBreak: "break-word",
                  textAlign: "justify",
                  whiteSpace: "pre-line",
                }}
              >
                {rendered}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
})}
    </div>
  )}
</div>
// til here
  );
}

  };
  return (
    <div className="form-wrapper">
      {/* PHASE 2 BUTTON */}
      <button
      type="button"
      className="filldgf-logout-btn"
      onClick={handleBackToHome}
    >
      Home
    </button>
      {/* --- Step Sidebar --- */}
      <div className="step-sidebar">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`step-circle ${index === currentStep ? "active" : ""} ${
              index < currentStep ? "completed" : ""
            }`}
            onClick={() => goToStep(index)} // 🔵 CLICK HANDLER
          >
            <span>{index + 1}</span>
            <p>{step}</p>
          </div>
        ))}
      </div>
      {/* --- Step Content --- */}
     <div className="step-content">
  <h2>{steps[currentStep] || "Overview"}</h2>
  {renderStepContent(currentStep)}

  {/* Hide Back/Next on FAQ and Overview */}
  {currentStep !== FAQ_STEP && currentStep !== OVERVIEW_STEP && (
    <div className="step-buttons">
      <button
        type="button"
        onClick={prevStep}
        disabled={currentStep === 0}
      >
        ⬅︎ Back
      </button>
      <button
  type="button"
  onClick={() => {
    const form = document.querySelector("form");
    if (!form.reportValidity()) return;   // ⛔ blocks Next until required fields are valid
    nextStep();                           // ✅ allows Next when all required inputs are filled correctly
  }}
>
  Next ➜
</button>

    </div>
  )}
</div>


    </div>
  ); 
}
export default MultiStepForm;
